webpackJsonp([4],{

/***/ "1FX4":
/***/ (function(module, exports) {

// 橡皮檫插件
var DrawBoard = window.DrawBoard;
var $ = window.jQuery;
var context = window.context;

var typeId = DrawBoard.getTypeId();

var $elemMenu = $('#eraser-dialog');

DrawBoard.addPlugin({
    type: typeId,
    name: 'eraser',
    init: function init() {
        var that = this;
        that.handlers[typeId] = {
            select: function select() {
                that.cursorLayer.ctx.fillStyle = '#999999';
                that.cursorLayer.ctx.strokeStyle = 'rgba(0,0,0,5)';
                that.cursorLayer.ctx.lineWidth = 1;

                that.$elem.css('cursor', 'none');
            },
            unselect: function unselect() {
                that.ctx.strokeStyle = 'rgba(250,250,250,1)';
                that.$elem.css('cursor', 'default');
            },
            mousemove: function mousemove(potx, poty) {
                if (that.isDown) {
                    that.newx = potx;
                    that.newy = poty;

                    that.resetEraser(that.oldx, that.oldy, that.newx, that.newy);
                    that.cursorLayer.show();

                    that.oldx = that.newx;
                    that.oldy = that.newy;
                }

                that.cursorLayer.ctx.strokeStyle = '#999';
                that.cursorLayer.ctx.clearRect(0, 0, that.width, that.height);
                that.cursorLayer.drawRound(potx, poty, that.eraserWidth / 2, false);
            },
            click: function click(potx, poty) {
                that.eraserCircle(potx, poty, that.eraserWidth / 2);
            },
            mouseout: function mouseout(potx, poty) {
                that.cursorLayer.ctx.clearRect(0, 0, that.width, that.height);
            },
            mousewheel: function mousewheel(potx, poty, delta) {
                if (delta > 0) {
                    that.eraserWidth += 2;
                } else {
                    that.eraserWidth -= 2;
                }

                if (that.eraserWidth < 1) {
                    that.eraserWidth = 1;
                }
                that.cursorLayer.ctx.clearRect(0, 0, that.width, that.height);
                that.cursorLayer.drawRound(potx, poty, that.eraserWidth / 2, false);
            },
            mouseup: function mouseup(potx, poty) {
                that.storage();
            },
            contextmenu: function contextmenu(potx, poty, e) {
                context($elemMenu, e);
            }
        };
    }
});

/***/ }),

/***/ "6KqF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9z10":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AQzq":
/***/ (function(module, exports) {

// 剪切插件
/* eslint-disable */
(function ($) {
    var typeId = DrawBoard.getTypeId();

    DrawBoard.addPlugin({
        type: typeId,
        name: 'cut',
        init: function init() {
            var that = this;

            that.cutDate = {
                isCut: false
            };
            var $elemMenu = $('#cut-menu');

            $('#cut-menu-cancel').on('click', function (e) {
                e.preventDefault();

                $elemMenu.hide();
                contextHide($('#cut-box'));
                that.cutDate.isCut = false;
            });

            $('#cut-menu-cut').on('click', function (e) {
                e.preventDefault();

                $elemMenu.hide();
                contextHide($('#cut-box'));
                that.cutDate.isCut = false;

                var width = that.cutDate.endX - that.cutDate.startX;
                var height = that.cutDate.endY - that.cutDate.startY;
                that.ctx.drawImage(that.layer.canvas, that.cutDate.startX, that.cutDate.startY, width, height, 0, 0, width, height);

                that.canvasSize(width, height);
                that.storage();
            });

            that.handlers[typeId] = {
                select: function select() {
                    that.ctx.strokeStyle = that.color;
                    that.ctx2.strokeStyle = that.color;
                    that.ctx2.lineWidth = 1;
                },
                click2: function click2(potx, poty) {
                    $elemMenu.hide();
                },
                mousedown: function mousedown(potx, poty) {
                    that.layer2.show();
                },
                mousemove: function mousemove(potx, poty) {
                    if (that.isDown) {
                        that.newx = potx;
                        that.newy = poty;

                        that.ctx2.clearRect(0, 0, that.width, that.height);
                        that.layer2.drawRect(that.oldx, that.oldy, that.newx, that.newy);
                    }
                },
                mouseup: function mouseup(potx, poty) {

                    var newx = potx;
                    var newy = poty;

                    var startX = that.oldx < potx ? that.oldx : potx;
                    var startY = that.oldy < poty ? that.oldy : poty;
                    var endX = that.oldx < potx ? potx : that.oldx;
                    var endY = that.oldy < poty ? poty : that.oldy;

                    that.cutDate.startX = startX;
                    that.cutDate.startY = startY;
                    that.cutDate.endX = endX;
                    that.cutDate.endY = endY;

                    //that.layer.drawRect(that.oldx, that.oldy, newx, newy)

                    $('#cut-box').show();

                    $('#cut-box').find('.ui-cut').css({
                        left: startX,
                        top: startY,
                        width: endX - startX,
                        height: endY - startY
                    });
                    $('#cut-box').find('.cut-overlay-top').height(startY);
                    $('#cut-box').find('.cut-overlay-bottom').css({
                        top: endY + 'px',
                        left: startX + 'px'
                    });
                    $('#cut-box').find('.cut-overlay-left').css({
                        top: startY + 'px',
                        width: startX + 'px'
                    });
                    $('#cut-box').find('.cut-overlay-right').css({
                        top: startY + 'px',
                        left: endX + 'px',
                        height: endY - startY + 'px'
                    });
                    that.layer2.clearRect();

                    that.cutDate.isCut = true;
                },
                contextmenu: function contextmenu(potx, poty, e) {

                    if (that.cutDate.isCut) {
                        context($elemMenu, e);
                    }
                }
            };
        }
    });
})(jQuery);

/***/ }),

/***/ "DxuS":
/***/ (function(module, exports) {

// 毛刷、喷枪插件
/* eslint-disable */
(function ($) {
    var typeId = DrawBoard.getTypeId();

    var linex = [];
    var liney = [];

    var $elemMenu = $('#pencil-dialog');

    DrawBoard.addPlugin({
        type: typeId,
        name: 'brush',
        init: function init() {
            var that = this;

            that.handlers[typeId] = {
                select: function select() {
                    that.ctx.strokeStyle = that.color;
                    //that.ctx.strokeStyle = 'rgba(0,0,0,.5)'


                    that.cursorLayer.ctx.fillStyle = "#999999";
                    that.cursorLayer.ctx.strokeStyle = that.color;
                    that.cursorLayer.ctx.lineWidth = 1;
                    that.$elem.css('cursor', 'none');
                },
                unselect: function unselect() {
                    that.ctx.strokeStyle = 'rgba(250,250,250,1)';
                    that.$elem.css('cursor', 'default');
                },
                mousedown: function mousedown(potx, poty) {
                    linex.push(potx);
                    liney.push(poty);

                    that.ctx2.beginPath();
                    that.ctx2.moveTo(potx, poty);
                },
                mouseout: function mouseout(potx, poty) {
                    that.cursorLayer.ctx.clearRect(0, 0, that.width, that.height);
                },
                mousemove: function mousemove(x, y) {
                    if (that.isDown) {
                        linex.push(x);
                        liney.push(y);
                        that.ctx2.lineTo(x, y);

                        that.ctx2.lineCap = "round";
                        that.ctx2.lineJoin = "round";
                        that.ctx2.lineWidth = that.lineWidth;

                        var rgb = Color.hex2Rbg(that.color);
                        var rgba = 'rgba(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ',' + that.opacity + ')';

                        var radialGradient = that.ctx2.createRadialGradient((lastX + x) / 2, (lastY + y) / 2, 0, (lastX + x) / 2, (lastY + y) / 2, that.lineWidth / 2);
                        radialGradient.addColorStop(0, 'rgba(255, 0, 0, 1)');
                        radialGradient.addColorStop(0.5, 'rgba(255, 0, 0, 0.6)');
                        radialGradient.addColorStop(1, 'rgba(255, 0, 0, 0)');
                        that.ctx2.beginPath();
                        that.ctx2.arc(x, y, that.lineWidth / 2, 0, Math.PI * 2, true);
                        that.ctx2.closePath();
                        that.ctx2.strokeStyle = radialGradient;

                        //that.ctx2.strokeStyle = "rgba(254,0,0,1)"
                        that.ctx2.globalCompositeOperation = "destination-out";
                        that.ctx2.stroke();

                        that.ctx2.strokeStyle = rgba;
                        that.ctx2.globalCompositeOperation = "source-over";
                        that.ctx2.stroke();

                        /*var radialGradient = that.ctx2.createRadialGradient (x, y, 0, x, y, that.lineWidth / 2)
                         radialGradient.addColorStop(0, 'rgba(255, 0, 0, 1)')
                         radialGradient.addColorStop(0.5, 'rgba(255, 0, 0, 0.6)')
                         radialGradient.addColorStop(1, 'rgba(255, 0, 0, 0)')
                         that.ctx2.beginPath()
                         that.ctx2.arc(x, y, that.lineWidth / 2, 0, Math.PI * 2, true)
                         that.ctx2.closePath()
                         that.ctx2.fillStyle = radialGradient
                         that.ctx2.fill();*/

                        lastX = x;
                        lastY = y;
                    }

                    //that.cursorLayer.ctx.strokeStyle = that.color
                    that.cursorLayer.ctx.strokeStyle = '#999';
                    that.cursorLayer.ctx.clearRect(0, 0, that.width, that.height);
                    that.cursorLayer.drawRound(x, y, that.lineWidth / 2, false);
                    that.cursorLayer.ctx.strokeStyle = '#999';
                    that.cursorLayer.drawLine(x - 4, y, x + 4, y);
                    that.cursorLayer.drawLine(x, y - 4, x, y + 4);
                },
                mouseup: function mouseup(potx, poty) {
                    that.ctx2.clearRect(0, 0, that.width, that.height);

                    if (linex.length > 0) {
                        var x = linex[0];
                        var y = liney[0];
                        that.ctx.beginPath();
                        that.ctx.moveTo(x, y);

                        for (var i = 1; i < linex.length; i++) {
                            x = linex[i];
                            y = liney[i];
                            that.ctx.lineTo(x, y);
                        }
                        linex.length = 0;
                        liney.length = 0;

                        that.ctx.lineCap = "round";
                        that.ctx.lineJoin = "round";
                        that.ctx.lineWidth = that.lineWidth;
                        var rgb = Color.hex2Rbg(that.color);
                        var rgba = 'rgba(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ',' + that.opacity + ')';
                        that.ctx.strokeStyle = rgba;
                        that.ctx.stroke();
                    }

                    if (potx === that.oldx && poty === that.oldy) {
                        var rgb = Color.hex2Rbg(that.color);
                        var rgba = 'rgba(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ',' + that.opacity + ')';
                        that.ctx.fillStyle = rgba;
                        that.layer.drawRound(potx, poty, that.lineWidth / 2, true);
                    }
                    that.storage();
                },
                contextmenu: function contextmenu(potx, poty, e) {
                    context($elemMenu, e);
                }
            };
        }
    });
})(jQuery);

/***/ }),

/***/ "ESOJ":
/***/ (function(module, exports) {

// 椭圆插件
var DrawBoard = window.DrawBoard;
var typeId = DrawBoard.getTypeId();

// 绘制椭圆
function ellipse(context, x, y, a, b) {
    context.save();
    var r = a > b ? a : b;
    var ratioX = a / r;
    var ratioY = b / r;
    context.scale(ratioX, ratioY);
    context.beginPath();
    context.arc(x / ratioX, y / ratioY, r, 0, 2 * Math.PI, false);
    context.closePath();
    context.restore();
    context.stroke();
}

DrawBoard.addPlugin({
    type: typeId,
    name: 'ellipse',
    init: function init() {
        var that = this;

        that.handlers[typeId] = {
            select: function select() {
                that.ctx.strokeStyle = that.color;
            },
            mousedown: function mousedown(potx, poty) {
                that.layer2.show();
            },
            mousemove: function mousemove(potx, poty) {
                if (that.isDown) {
                    that.newx = potx;
                    that.newy = poty;

                    that.ctx2.clearRect(0, 0, that.width, that.height);
                    ellipse(that.layer2.ctx, (that.oldx + that.newx) / 2, (that.oldy + that.newy) / 2, (that.newx - that.oldx) / 2, (that.newy - that.oldy) / 2);
                }
            },
            mouseup: function mouseup(potx, poty) {
                that.layer2.clearRect();
                ellipse(that.layer.ctx, (that.oldx + that.newx) / 2, (that.oldy + that.newy) / 2, (that.newx - that.oldx) / 2, (that.newy - that.oldy) / 2);
                that.storage();
            }
        };
    }
});

/***/ }),

/***/ "Je60":
/***/ (function(module, exports) {

// 指针插件（移动图像）
var DrawBoard = window.DrawBoard;

var typeId = DrawBoard.getTypeId();

var startX;
var startY;
var endX;
var endY;
var hasMove = false;

DrawBoard.addPlugin({
    type: typeId,
    name: 'pointer',
    init: function init() {
        var that = this;

        that.handlers[typeId] = {
            mousedown: function mousedown(potx, poty) {
                startX = potx;
                startY = poty;
            },
            mouseout: function mouseout(potx, poty) {},
            mousemove: function mousemove(x, y) {
                if (that.isDown) {
                    hasMove = true;
                    that.layer.canvas.style.left = x - startX + 'px';
                    that.layer.canvas.style.top = y - startY + 'px';
                    endX = x;
                    endY = y;
                }
            },
            mouseup: function mouseup(potx, poty) {
                if (hasMove) {
                    that.layer.canvas.style.left = '0px';
                    that.layer.canvas.style.top = '0px';
                    var x = endX - startX;
                    var y = endY - startY;
                    that.layer2.ctx.drawImage(that.layer.canvas, 0, 0, that.width - x, that.height - y, x, y, that.width - x, that.height - y);
                    that.layer.clearRect(0, 0, that.width, that.height);
                    that.layer.ctx.drawImage(that.layer2.canvas, 0, 0, that.width, that.height, 0, 0, that.width, that.height);
                    that.layer2.clearRect(0, 0, that.width, that.height);
                }
                // that.storage()
            }
        };
    }
});

/***/ }),

/***/ "Jvam":
/***/ (function(module, exports) {

/* eslint-disable */

// 模糊橡皮檫插件
(function ($) {
    var typeId = DrawBoard.getTypeId();

    DrawBoard.addPlugin({
        type: typeId,
        name: 'vague_eraser',
        init: function init() {
            var that = this;
            that.handlers[typeId] = {
                select: function select() {
                    that.cursorLayer.ctx.fillStyle = "#999999";
                    that.cursorLayer.ctx.strokeStyle = 'rgba(0,0,0,5)';
                    that.cursorLayer.ctx.lineWidth = 1;

                    that.$elem.css('cursor', 'none');
                },
                unselect: function unselect() {
                    that.ctx.strokeStyle = 'rgba(250,250,250,1)';
                    that.$elem.css('cursor', 'default');
                },
                mousemove: function mousemove(potx, poty) {
                    if (that.isDown) {

                        that.newx = potx;
                        that.newy = poty;

                        that.resetEraser2(that.oldx, that.oldy, that.newx, that.newy);
                        that.cursorLayer.show();

                        that.oldx = that.newx;
                        that.oldy = that.newy;
                    }

                    that.cursorLayer.ctx.strokeStyle = '#999';
                    that.cursorLayer.ctx.clearRect(0, 0, that.width, that.height);
                    var half = that.eraserWidth / 2;
                    //that.drawRect(potx - half, poty - half, potx + half, poty + half, that.ctx2, true)
                    that.cursorLayer.drawRound(potx, poty, that.eraserWidth / 2, false);
                },
                click: function click(potx, poty) {
                    that.resetEraser2(that.oldx, that.oldy, potx, poty);
                },
                mouseout: function mouseout(potx, poty) {
                    that.cursorLayer.ctx.clearRect(0, 0, that.width, that.height);
                },
                mousewheel: function mousewheel(potx, poty, delta) {
                    if (delta > 0) {
                        that.eraserWidth += 2;
                    } else {
                        that.eraserWidth -= 2;
                    }

                    if (that.eraserWidth < 1) {
                        that.eraserWidth = 1;
                    }
                    that.cursorLayer.ctx.clearRect(0, 0, that.width, that.height);
                    var half = that.eraserWidth / 2;
                    //that.drawRect(potx - half, poty - half, potx + half, poty + half, that.ctx2, true)
                    that.cursorLayer.drawRound(potx, poty, that.eraserWidth / 2, false);
                },
                mouseup: function mouseup(potx, poty) {
                    that.storage();
                },
                contextmenu: function contextmenu(potx, poty, e) {
                    context($elemMenu, e);
                }
            };
        }
    });
})(jQuery);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: external "Vue"
var external__Vue_ = __webpack_require__("lRwf");
var external__Vue__default = /*#__PURE__*/__webpack_require__.n(external__Vue_);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.4@babel-loader/lib!./node_modules/_vue-loader@13.7.1@vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//

/* harmony default export */ var App = ({});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.1@vue-loader/lib/template-compiler?{"id":"data-v-3b0e0fbc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.1@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("6KqF")
}
var normalizeComponent = __webpack_require__("Z0/y")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: external "VueRouter"
var external__VueRouter_ = __webpack_require__("pRNm");
var external__VueRouter__default = /*#__PURE__*/__webpack_require__.n(external__VueRouter_);

// CONCATENATED MODULE: ./src/router/index.js



var Home = function Home(resolve) {
    return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("j7e0")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var About = function About(resolve) {
    return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("vu9I")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Help = function Help(resolve) {
    return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("LbE0")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

external__Vue__default.a.use(external__VueRouter__default.a);

/* harmony default export */ var router = (new external__VueRouter__default.a({
    mode: 'history',
    routes: [{
        path: '/',
        component: Home
    }, {
        path: '/about',
        component: About
    }, {
        path: '/help',
        component: Help
    }]
}));
// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("AA3o");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("xSur");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// CONCATENATED MODULE: ./src/js/layer.js
// Layer class
function Layer(draw, canvas) {
  var that = this;

  that.canvas = canvas;
  that.width = draw.width;
  that.height = draw.height;
  that.canvas.width = that.width;
  that.canvas.height = that.height;
  // 图层属性
  that.visibility = true; // 可见性
  that.opacity = 1; // 不透明度
  that.type = 0; // 图层类型

  that.ctx = that.canvas.getContext('2d');
  that.ctx.lineJoin = 'round';
  that.ctx.lineCap = 'round'; // 设置笔迹边角，否则笔迹会出现断层
}

Layer.prototype.show = function () {
  this.visibility = true;
  this.canvas.style.display = 'block';
};

Layer.prototype.hide = function () {
  this.visibility = false;
  this.canvas.style.display = 'none';
};

Layer.prototype.drawLine = function (x1, y1, x2, y2) {
  var that = this;

  var ctx = that.ctx;
  ctx.beginPath();
  ctx.moveTo(x1, y1);
  ctx.lineTo(x2, y2);
  ctx.lineCap = 'round';
  ctx.stroke();
};

Layer.prototype.drawRect = function (x1, y1, x2, y2, type) {
  var that = this;

  var ctx = that.ctx;
  ctx.beginPath();
  var width = Math.abs(x1 - x2);
  var height = Math.abs(y1 - y2);
  var minx = Math.min(x1, x2);
  var miny = Math.min(y1, y2);
  ctx.rect(minx, miny, width, height);
  if (type) {
    ctx.fill();
  } else {
    ctx.stroke();
  }
};

Layer.prototype.drawRound = function (x, y, radius, fill) {
  var that = this;

  var ctx = that.ctx;
  ctx.beginPath();
  ctx.arc(x, y, radius, 0, Math.PI * 2);

  if (fill) {
    ctx.fill();
  } else {
    ctx.stroke();
  }
};

Layer.prototype.clearRect = function (x, y, w, h) {
  if (x) {
    this.ctx.clearRect(x, y, w, h);
  } else {
    this.ctx.clearRect(0, 0, this.width, this.height);
  }
};

/* harmony default export */ var js_layer = (Layer);
// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("3cXf");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// CONCATENATED MODULE: ./src/js/util/storage.js

var storage = {
  setItem: function setItem(key, value) {
    localStorage.setItem(key, stringify_default()(value));
  },
  getItem: function getItem(key, defaultValue) {
    defaultValue = defaultValue || null;
    try {
      var data = localStorage.getItem(key);
      if (!data) {
        return defaultValue;
      }
      return JSON.parse(data);
    } catch (e) {
      return defaultValue;
    }
  }
};

/* harmony default export */ var util_storage = (storage);
// CONCATENATED MODULE: ./src/js/draw-base.js




var $ = window.jQuery;
var ui = window.ui; // TODO

// DrawBoard class

var draw_base_DrawBoard = function () {
  function DrawBoard(elem, option) {
    classCallCheck_default()(this, DrawBoard);

    var that = this;

    var opts = $.extend({}, DrawBoard.DEFAULTS, option);
    that.opts = opts;

    that.$elem = $('#' + elem);
    that.elem = that.$elem[0];

    that.setSize(opts.width || 600, opts.height || 600);

    that.totalLayer = 0; // 图层数

    that.$box = $('<div></div>');
    that.$elem.append(that.$box);
    that.$box.css({
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%'
    });

    that.layer_1 = that.createLayer(0);
    that.layer_2 = that.createLayer(1);
    that.layer2 = that.createLayer(10, true); // 辅助图层
    that.cursorLayer = that.createLayer(9, true); // 鼠标绘制图层

    // that.curLayer = 1
    that.layersEx = [that.layer2, that.cursorLayer];
    that.layers = [that.layer_1, that.layer_2];
    that.setLayer(2);

    that.ctx = that.layer.ctx;
    that.ctx2 = that.layer2.ctx;

    that.offsetX = that.$elem.offset().left;
    that.offsetY = that.$elem.offset().top;

    that.isDown = false; // 按下标记
    that.oldx = -10;
    that.oldy = -10;

    // 初始化
    that.type = -1; // TODO 重要
    that._setColor('#000');
    that.eraserWidth = 5;
    that.bgColor = '#fff';

    that.isPlaying = false;

    that.lineWidth = 1;
    that.opacity = 1;

    that.ctx.lineWidth = that.lineWidth;
    that.ctx2.lineWidth = that.lineWidth;

    that.initHistory();

    that.log = [];

    that.startState = that.getState();

    that.handlers = {};

    that.event();
  }

  // 清空历史记录


  createClass_default()(DrawBoard, [{
    key: 'clearHistory',
    value: function clearHistory() {
      var that = this;
      that.history = [];
      that.historyCount = -1;
      that.curHistory = -1;
    }
  }]);

  return DrawBoard;
}();
/*
var path = new Path2D("M10 10 h 80 v 80 h -80 Z")
that.ctx.fill(path)
*/

window.DrawBoard = draw_base_DrawBoard;

draw_base_DrawBoard.DEFAULTS = {
  log: false // 是否保存历史记录
};

var fn = draw_base_DrawBoard.prototype;
draw_base_DrawBoard.fn = fn;

// 初始化历史记录
fn.initHistory = function () {
  var that = this;

  // 保存历史记录
  that.history = []; // 保存历史记录，索引0保存最初的状态
  that.historyCount = -1;
  that.curHistory = -1;
  that.startStorage = that.storage(true);
};

// 获取历史记录
fn.getHistory = function (index) {
  var that = this;
  return that.history[index];
};

// 保存当前状态
fn.storage = function (init) {
  var that = this;
  if (!that.opts.log) {
    return;
  }

  var dataUrl = that.layer.canvas.toDataURL();
  if (init) {
    that.historyCount = 1;
    that.curHistory = 0;
  } else {
    that.historyCount++;
    that.curHistory++;
    // 撤销多步时
    if (that.historyCount > that.curHistory + 1) {
      that.historyCount = that.curHistory + 1;
    }
  }

  that.history[that.curHistory] = {
    data: dataUrl,
    width: that.width,
    height: that.height
  };

  return that.curHistory;
};

// 创建图层
fn.createLayer = function (id, isTemp) {
  var that = this;

  var $canvas = $('<canvas id="mycanvas-' + id + '" class="canvas">您的浏览器不支持 canvas 标签</canvas>');
  if (isTemp) {
    that.$elem.append($canvas);
  } else {
    that.$box.append($canvas);
  }

  $canvas.css({
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%'
  });

  // 临时图层则
  if (isTemp) {
    //
  } else {
    that.totalLayer += 1;
  }

  return new js_layer(that, $canvas[0]);
};

// 设置当前图层
fn.setLayer = function (index) {
  var that = this;

  that.curLayer = index;
  that.layer = that.layers[index - 1];
  that.ctx = that.layer.ctx;

  that.layer.ctx.lineWidth = that.lineWidth;
  that.layer.ctx.strokeStyle = that.color;
  that.layer.ctx.fillStyle = that.color;
};

// 删除图层
fn.removeLayer = function (index) {
  var that = this;
  that.totalLayer--;
  that.layers.splice(index - 1, 1);
  console.log(index - 1);
  $('#mycanvas' + (index - 1)).remove();
  $('#layer-list').find('[data-layer=' + (index - 1) + ']').remove();
};

// 添加图层
fn.addLayer = function (index) {
  var that = this;
  var layer = that.createLayer(3); // TODO
  that.layers.push(layer);
};

fn.event = function () {
  var that = this;

  var $position = $('#position');

  var workplaceBox = document.getElementById('workplace-box');
  function coord(e) {
    return {
      x: e.pageX - that.offsetX + workplaceBox.scrollLeft,
      y: e.pageY - that.offsetY + workplaceBox.scrollTop
    };
  }

  // 事件
  that.$elem.on('mousemove', function draw(e) {
    var pt = coord(e);
    $position.text('(' + pt.x + ', ' + pt.y + ')');

    if (that.isPlaying) {
      return;
    }

    that.move(pt.x, pt.y, e);
  });

  fn.move = function (x, y) {
    var that = this;

    if (that.handlers[that.type] && that.handlers[that.type].mousemove) {
      that.handlers[that.type].mousemove(x, y);
    }

    if (that.isDown) {
      that.addLog({
        type: 'move',
        x: x,
        y: y
      });
    }
  };

  that.$elem.on('mousedown', function (e) {
    if (e.button === 2) {
      return;
    }
    var pt = coord(e);

    if (that.isPlaying) {
      return;
    }

    that.downA(pt.x, pt.y, e);

    that.addLog({
      type: 'down',
      x: pt.x,
      y: pt.y
    });
  });

  that.$elem.on('mouseup', function (e) {
    if (e.button === 2) {
      return;
    }

    var pt = coord(e);

    if (that.isPlaying) {
      return;
    }

    that.up(pt.x, pt.y, e);

    that.addLog({
      type: 'up',
      x: pt.x,
      y: pt.y
    });
  });

  that.$elem.on('mouseout', function (e) {
    var pt = coord(e);
    that.out(pt.x, pt.y);
  });

  that.$elem.on('click', function (e) {
    if (that.handlers[that.type] && that.handlers[that.type].click) {
      var pt = coord(e);

      that.handlers[that.type].click(pt.x, pt.y);
    }
  });
  var $workplace = $('#workplace');
  $workplace.on('click', function (e) {
    if (that.handlers[that.type] && that.handlers[that.type].click2) {
      var pt = coord(e);

      that.handlers[that.type].click2(pt.x, pt.y);
    }
    return true;
  });
  $workplace.on('contextmenu', function (e) {
    if (that.handlers[that.type] && that.handlers[that.type].contextmenu) {
      var pt = coord(e);

      that.handlers[that.type].contextmenu(pt.x, pt.y, e);

      return false;
    }

    return true;
  });

  that.$elem.on('mousewheel', function (e, delta) {
    var pt = coord(e);

    if (that.handlers[that.type] && that.handlers[that.type].mousewheel) {
      that.handlers[that.type].mousewheel(pt.x, pt.y, delta);
      return false;
    }

    // 禁止网页缩放
    return !e.ctrlKey;
  });
};

fn.destroy = function () {};

// 加载本地存储
fn.loadStorage = function () {
  var that = this;

  var width = util_storage.getItem('width');
  var height = util_storage.getItem('height');
  if (width && height) {
    that.canvasSize(width, height);
  }
  var layers = util_storage.getItem('canvas');
  if (layers) {
    var loadNum = 0;
    for (var i = 0; i < layers.length; i++) {
      var image = new Image();
      image.src = layers[i].dataUrl;(function (idx, img) {
        img.onload = function () {
          that.layers[idx].ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, that.width, that.height);
          // 等所有图层加载完后，保存记录
          loadNum++;
          if (loadNum === layers.length) {
            that.storage(true);
          }
        };
      })(i, image);
    }
  }

  // 加载配置
  that._setEraserWidth(util_storage.getItem('eraserWidth'));
  that._setElemBgColor(util_storage.getItem('bgColor', '#fff'));

  // 加载历史
  var log = util_storage.getItem('log');
  if (log) {
    // that.log = log; TODO 还有bug
  }
};

// 设置画板大小
fn.setSize = function (width, height) {
  var that = this;

  that.width = width;
  that.height = height;

  that.$elem.width(width);
  that.$elem.height(height);
};

draw_base_DrawBoard.fn.canvasSize = function (width, height) {
  var that = this;

  var canvasData = that.ctx.getImageData(0, 0, that.width, that.height);

  that.setSize(width, height);
  $('#editor-canvas-width').text(width + 'px');
  $('#editor-canvas-height').text(height + 'px');
  /*
  for (var i = 0, len = that.layers.length; i < len; i++) {
      that.layers[i].width = width
      that.layers[i].height = height
  }
  for (var i = 0, len = that.layersEx.length; i < len; i++) {
      that.layersEx[i].width = width
      that.layersEx[i].height = height
  }
  */
  that.layer.canvas.width = width;
  that.layer.canvas.height = height;
  that.layer2.canvas.width = width;
  that.layer2.canvas.height = height;
  that.cursorLayer.canvas.width = width;
  that.cursorLayer.canvas.height = height;

  that.ctx.putImageData(canvasData, 0, 0);
};

// 保存开始设置
fn.getState = function () {
  var that = this;

  return {
    color: that.color,
    type: that.type,
    lineWidth: that.lineWidth
  };
};

// 选择
fn.select = function () {
  var that = this;

  // 绘制蚂蚁线
  function ants() {
    var canvas = that.layers[1].canvas;
    var context = canvas.getContext('2d');

    var imageData = context.getImageData(0, 0, canvas.width, canvas.height);
    var outlineMask = createOutlineMask(imageData, 0xC0);
    var offset = 0;
    var TIME = 167;
    setInterval(function () {
      that.ctx2.putImageData(renderMarchingAnts(imageData, outlineMask, offset -= 2), 0, 0);
    }, TIME);
  }

  function renderMarchingAnts(imageData, outlineMask, antOffset) {
    var data = imageData.data;
    var width = imageData.width;
    var height = imageData.height;
    var outline = outlineMask.data;

    for (var y = 0; y < height; y++) {
      for (var x = 0; x < width; x++) {
        var offset = (y * width + x) * 4;
        var isEdge = outline[offset] === 0x00;

        if (isEdge) {
          var value = ant(x, y, antOffset);
          data[offset] = value;
          data[offset + 1] = value;
          data[offset + 2] = value;
          data[offset + 3] = 0xFF;
        } else {
          data[offset + 3] = 0x00;
        }
      }
    }

    return imageData;
  }

  function ant(x, y, offset) {
    return (6 + y + offset % 12 + x) % 12 > 6 ? 0x00 : 0xFF;
  }

  function createOutlineMask(srcImageData, threshold) {
    var srcData = srcImageData.data;
    var width = srcImageData.width;
    var height = srcImageData.height;

    function get(x, y) {
      if (x < 0 || x >= width || y < 0 || y >= height) return;
      var offset = (y * width + x) * 4;
      return srcData[offset + 3];
    }

    var context = createContext(width, height);
    var dstImageData = context.getImageData(0, 0, width, height);
    var dstData = dstImageData.data;

    function set(x, y, value) {
      var offset = (y * width + x) * 4;
      dstData[offset] = value;
      dstData[offset + 1] = value;
      dstData[offset + 2] = value;
      dstData[offset + 3] = 0xFF;
    }

    function match(x, y) {
      var alpha = get(x, y);
      return alpha == null || alpha >= threshold;
    }

    function isEdge(x, y) {
      return !match(x - 1, y - 1) || !match(x + 0, y - 1) || !match(x + 1, y - 1) || !match(x - 1, y + 0) || false || !match(x + 1, y + 0) || !match(x - 1, y + 1) || !match(x + 0, y + 1) || !match(x + 1, y + 1);
    }

    for (var y = 0; y < height; y++) {
      for (var x = 0; x < width; x++) {
        if (match(x, y) && isEdge(x, y)) {
          set(x, y, 0x00);
        } else {
          set(x, y, 0xFF);
        }
      }
    }

    return dstImageData;
  }

  function createContext(width, height) {
    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');
    canvas.width = width;
    canvas.height = height;
    return context;
  }

  ants();
};

fn.loadState = function (state) {
  var that = this;

  that.setColor(state.color);
  that._setType(state.type);
  that._setWidth(state.lineWidth);
};

fn.downA = function (potx, poty, e) {
  var that = this;

  that.isDown = true;

  that.oldx = potx;
  that.oldy = poty;

  if (that.handlers[that.type] && that.handlers[that.type].mousedown) {
    that.handlers[that.type].mousedown(potx, poty, e);
  }
};

fn.out = function (potx, poty, e) {
  var that = this;

  if (that.handlers[that.type] && that.handlers[that.type].mouseout) {
    that.handlers[that.type].mouseout(potx, poty, e);
  }
};

fn.up = function (potx, poty, e) {
  var that = this;

  that.isDown = false;
  if (that.handlers[that.type] && that.handlers[that.type].mouseup) {
    that.handlers[that.type].mouseup(potx, poty, e);
  }
};

fn.getDataUrl = function () {
  var that = this;
  // 存储图层信息
  var layers = [];
  for (var i = 0; i < that.layers.length; i++) {
    layers.push({
      dataUrl: that.layers[i].canvas.toDataURL('image/png')
    });
  }
  // 本地存储
  util_storage.setItem('canvas', layers);
  util_storage.setItem('width', that.width);
  util_storage.setItem('height', that.height);
  util_storage.setItem('bgColor', that.bgColor);

  // 把所有图层绘制到临时图层上
  that.layer2.hide();
  that.layer2.clearRect();
  if (that.bgColor !== 'transparent') {
    that.ctx2.fillStyle = that.bgColor;
    that.ctx2.fillRect(0, 0, that.width, that.height);
  }
  that.ctx2.drawImage(that.layer.canvas, 0, 0, that.width, that.height);
  var dataUrl = that.layer2.canvas.toDataURL('image/png');
  that.layer2.clearRect();
  that.layer2.show();

  // 播放操作记录
  util_storage.setItem('log', that.log);
  return dataUrl;
};

fn.save = function () {
  var dataUrl = this.getDataUrl();
  $('#download')[0].href = dataUrl;
};

fn.small = function () {
  ui.msg('小');
};

fn.rotate = function () {
  var ctx = this.layer.ctx;
  /*
  var imgData = ctx.getImageData(0, 0, 500, 250)
  ctx.rotate(90)
  ctx.translate(100, 100)
  ctx.putImageData(imgData, 0, 250);
  */

  var canvas = this.layer.canvas;
  var imageObject = new Image();
  imageObject.src = canvas.toDataURL();
  imageObject.onload = function () {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    // ctx.rotate(10)
    ctx.scale(1.2, 1.2);
    ctx.drawImage(imageObject, 0, 0);
  };
};

fn.setBgColor = function (color) {
  var that = this;
  that.bgColor = color;
  that.$elem.css('background-color', color);

  // log     TODO
};

fn.setColor = function (color) {
  var that = this;

  that._setColor(color);
  that.addLog({
    type: 'color',
    color: color
  });
};

// 设置画笔颜色
fn._setColor = function (color) {
  var that = this;

  that.color = color;

  that.ctx.strokeStyle = color;
  that.ctx2.strokeStyle = color;
  that.ctx.fillStyle = color;
  that.ctx2.fillStyle = color;
};

fn._setElemBgColor = function (color) {
  var that = this;
  if (color === 'transparent') {
    that.$elem.css({
      'background-image': 'url("/static/img/canvas-bg.jpg")',
      'background-color': 'transparent'
    });
    that.bgColor = 'transparent';
  } else {
    that.$elem.css({
      'background-image': 'none',
      'background-color': color
    });
    that.bgColor = color;
  }
};

// 新建
fn.new = function (width, height, bg) {
  var that = this;
  that.clear(); // TODO 多图层删除
  that.canvasSize(width, height);
  var bgColor = bg === 0 ? '#fff' : 'transparent';
  that._setElemBgColor(bgColor);

  // that.storage(); TODO delete
  that.clearHistory();
  that.log = [];
};

fn.open = function (img) {
  var that = this;
  var image = new Image();
  image.src = img.src;
  image.onload = function () {
    that.canvasSize(image.width, image.height);
    that.ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, that.width, that.height);
  };

  // that.canvasSize(image.width , image.height)
  // that.ctx.drawImage(image , 0 ,0 , image.width , image.height , 0 ,0 , that.width, that.height)
};

fn.setWidth = function (width) {
  var that = this;

  that._setWidth(width);
  that.addLog({
    type: 'lineWidth',
    value: width
  });
};

fn.setOpacity = function (opacity) {
  var that = this;

  that.opacity = opacity;
  // TODO log
  /*
  that._setWidth(width)
  that.addLog({
      type: 'lineWidth',
      value: width
  });
  */
};

fn._setWidth = function (width) {
  var that = this;

  that.lineWidth = width;
  that.ctx.lineWidth = width;
  that.ctx2.lineWidth = width;
};

fn.setEraserWidth = function (width) {
  var that = this;

  util_storage.setItem('eraserWidth', width);
  that._setEraserWidth(width);
  that.addLog({
    type: 'eraserWidth',
    value: width
  });
};

fn._setEraserWidth = function (width) {
  this.eraserWidth = width;
};

fn.clear = function () {
  this.layer.clearRect();
  this.addLog({
    type: 'clear'
  });
};

fn._setType = function (type) {
  var that = this;

  if (type === that.type) {
    return;
  }
  // TODO 这里的代码移到 usePlugin ?
  if (that.handlers[that.type] && typeof that.handlers[that.type].unselect === 'function') {
    that.handlers[that.type].unselect();
  }
  if (that.handlers[type] && typeof that.handlers[type].select === 'function') {
    that.handlers[type].select();
  }
  that.type = type;
};

fn.undo = function () {
  this._undo();
  this.addLog({
    type: 'undo'
  });
};

// 撤销
fn._undo = function () {
  var that = this;

  if (that.curHistory > 0) {
    that.curHistory--;
    var history = that.history[that.curHistory];
    var dataUrl = history.data;

    that.canvasSize(history.width, history.height);

    that.layer.clearRect();
    var image = new Image();
    image.src = dataUrl;
    image.onload = function () {
      that.ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, that.width, that.height);
    };
  } else {
    ui.msg('不能再回退了');
  }
};

fn.loadStorage2 = function (index) {
  var that = this;

  if (index < 0) {
    return;
  }

  var dataUrl = that.history[index].data;
  var image = new Image();
  image.src = dataUrl;
  image.onload = function () {
    that.ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, that.width, that.height);
  };
};

fn.addLog = function (log) {
  var that = this;

  if (!that.isPlaying) {
    that.log.push(log);
  }
};

// 回放
fn.play = function () {
  var that = this;
  that.cancelPlayTag = false;

  if (that.log.length === 0) {
    ui.msg('没内容可以播放，请先绘画再播放');
    return;
  }

  that.isPlaying = true;

  that.curState = that.getState();
  that.loadState(that.startState);

  that.layer.clearRect();
  that.loadStorage2(that.startStorage);

  var i = 0;
  var id = setInterval(function () {
    console.log('12');
    if (i < that.log.length && !that.cancelPlayTag) {
      var log = that.log[i];
      switch (log.type) {
        case 'move':
          that.move(log.x, log.y);
          break;
        case 'up':
          that.up(log.x, log.y);
          break;
        case 'down':
          that.downA(log.x, log.y);
          break;
        case 'color':
          that.setColor(log.color);
          break;
        case 'type':
          that._setType(log.value);
          break;
        case 'lineWidth':
          that._setWidth(log.value);
          break;
        case 'redo':
          that._redo();
          break;
        case 'undo':
          that._undo();
          break;
        case 'clear':
          that.layer.clearRect();
          break;
        case 'EraserWidth':
          that._setEraserWidth(log.value);
          break;
      }
      i++;
    } else {
      that.cancelPlayTag = false;
      that.isPlaying = false;
      clearInterval(id);
      that.loadState(that.curState);
      // that.loadState(that.curState)
    }
  }, 10);
};

// 取消回放
fn.cancelPlay = function () {
  var that = this;
  that.cancelPlayTag = true;
};

fn.redo = function () {
  this._redo();
  this.addLog({
    type: 'redo'
  });
};

// 重做
fn._redo = function () {
  var that = this;

  if (that.curHistory < that.historyCount - 1) {
    that.curHistory++;

    var history = that.history[that.curHistory];
    var dataUrl = history.data;

    that.canvasSize(history.width, history.height);

    that.layer.clearRect();
    var image = new Image();
    image.src = dataUrl;
    image.onload = function () {
      that.ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, that.width, that.height);
    };
  } else {
    ui.msg('没有可恢复的内容了');
  }
};

// 擦除两点之间的图像
fn.resetEraser = function (oldx, oldy, newx, newy) {
  var ctx = this.ctx;
  ctx.lineCap = 'round';
  ctx.lineJoin = 'round';
  ctx.lineWidth = this.eraserWidth;
  ctx.globalCompositeOperation = 'destination-out';
  ctx.beginPath();
  ctx.moveTo(oldx, oldy);
  ctx.lineTo(newx, newy);
  ctx.stroke();
  ctx.globalCompositeOperation = 'source-over';
};

fn.resetEraser = function (oldx, oldy, newx, newy) {
  var ctx = this.ctx;
  ctx.lineCap = 'round';
  ctx.lineJoin = 'round';
  ctx.lineWidth = this.eraserWidth;
  ctx.globalCompositeOperation = 'destination-out';
  ctx.beginPath();
  ctx.moveTo(oldx, oldy);
  ctx.lineTo(newx, newy);
  ctx.stroke();
  ctx.globalCompositeOperation = 'source-over';
};

fn.eraserCircle = function (x, y, r) {
  var ctx = this.ctx;
  ctx.lineCap = 'round';
  ctx.lineJoin = 'round';
  ctx.lineWidth = this.eraserWidth;
  ctx.globalCompositeOperation = 'destination-out';
  ctx.beginPath();
  ctx.arc(x, y, r, 0, Math.PI * 2);
  ctx.fill();
  ctx.globalCompositeOperation = 'source-over';
};

// 透明度擦除（TODO 模糊擦除）
fn.resetEraser2 = function (oldx, oldy, newx, newy) {
  var ctx = this.ctx;
  ctx.lineCap = 'round';
  ctx.lineJoin = 'round';
  ctx.lineWidth = this.eraserWidth;
  ctx.globalCompositeOperation = 'destination-out';
  ctx.beginPath();
  ctx.moveTo(oldx, oldy);
  ctx.lineTo(newx, newy);
  ctx.stroke();
  ctx.globalCompositeOperation = 'source-over';
};

// / 插件相关
draw_base_DrawBoard.plugins = {};
draw_base_DrawBoard.typeId = 100000;
draw_base_DrawBoard.getTypeId = function () {
  return draw_base_DrawBoard.typeId++;
};
draw_base_DrawBoard.addPlugin = function (plugin) {
  // plugin.type = DrawBoard._getTypeId()
  draw_base_DrawBoard.plugins[plugin.name] = plugin;
};
fn.usePlugin = function (pluginName) {
  var plugin = draw_base_DrawBoard.plugins[pluginName];
  if (!plugin) {
    console.error('加载不到插件：' + pluginName);
    return;
  }
  if (!plugin.hasInit) {
    plugin.hasInit = true;
    plugin.init.call(this);
  }

  this._setType(plugin.type);
  this.addLog({
    type: 'type',
    value: plugin.type
  });
};

function Plugin(option) {
  // eslint-disable-next-line
  new draw_base_DrawBoard(this, option);
}

$.fn.drawBoard = Plugin;

window.DrawBoard = draw_base_DrawBoard;
// EXTERNAL MODULE: ./src/js/plugin/pencil.js
var pencil = __webpack_require__("vvaA");
var pencil_default = /*#__PURE__*/__webpack_require__.n(pencil);

// EXTERNAL MODULE: ./src/js/plugin/eraser.js
var eraser = __webpack_require__("1FX4");
var eraser_default = /*#__PURE__*/__webpack_require__.n(eraser);

// EXTERNAL MODULE: ./src/js/plugin/vagueEraser.js
var vagueEraser = __webpack_require__("Jvam");
var vagueEraser_default = /*#__PURE__*/__webpack_require__.n(vagueEraser);

// CONCATENATED MODULE: ./src/js/tool.js
function random(max, min) {
  if (typeof max !== 'number') {
    return Math.random();
  } else if (typeof min !== 'number') {
    min = 0;
  }
  return Math.random() * (max - min) + min;
}

function clamp(val, min, max) {
  return Math.min(max, Math.max(min, val));
}


// CONCATENATED MODULE: ./src/js/plugin/crayon.js
// 蜡笔插件

var crayon_DrawBoard = window.DrawBoard;

var typeId = crayon_DrawBoard.getTypeId();

crayon_DrawBoard.addPlugin({
    type: typeId,
    name: 'crayon',
    init: function init() {
        var that = this;

        that.handlers[typeId] = {
            select: function select() {
                that.ctx.strokeStyle = that.color;
            },
            mousemove: function mousemove(potx, poty) {
                if (that.isDown) {
                    that.newx = potx;
                    that.newy = poty;

                    that.size = 8;
                    var s = Math.ceil(that.size / 2); // 算出粒子的单位长度
                    var vlength = Math.sqrt((that.oldx - that.newx) * (that.oldx - that.newx) + (that.oldy - that.newy) * (that.oldy - that.newy));
                    var stepNum = Math.floor(vlength / s) + 1; // 算出步长  vlength为斜线长度

                    that._latestStrokeLength = vlength;

                    var INK_AMOUNT = 15; // 画笔的粒子数量，控制笔划的浓密程度

                    var sep = 1.5; // 分割数  控制画笔的浓密程度  关键所在
                    // 粒子的大小 根据画笔描绘的速度（画笔的停留时间）进行调整
                    var dotSize = sep * Math.min(INK_AMOUNT / that._latestStrokeLength * 3, 1);
                    var dotNum = Math.ceil(that.size * sep);
                    var range = that.size / 2;
                    var i, j, r, c, x, y;

                    that.ctx.save();

                    that.ctx.beginPath();

                    var nx = (that.newx - that.oldx) / vlength * s;
                    var ny = (that.newy - that.oldy) / vlength * s;

                    for (i = 0; i < dotNum; i++) {
                        for (j = 0; j < stepNum; j++) {
                            // p = this._latest.add(v.scale(j))

                            var px = that.oldx + nx * j;
                            var py = that.oldy + ny * j;
                            r = random(range);
                            c = random(Math.PI * 2);
                            var w = random(dotSize, dotSize / 2);
                            var h = random(dotSize, dotSize / 2);
                            x = px + r * Math.sin(c) - w / 2;
                            y = py + r * Math.cos(c) - h / 2;
                            that.ctx.rect(x, y, w, h);
                            // ctx.arc(x,y,w,0,Math.PI * 2,true)
                        }
                    }
                    that.ctx.fill();

                    that.oldx = that.newx;
                    that.oldy = that.newy;
                }
            },
            mouseup: function mouseup(potx, poty) {
                that.storage();
            }
        };
    }
});
// EXTERNAL MODULE: ./src/js/plugin/straw.js
var straw = __webpack_require__("uwNC");
var straw_default = /*#__PURE__*/__webpack_require__.n(straw);

// EXTERNAL MODULE: ./src/js/plugin/select.js
var plugin_select = __webpack_require__("qBwY");
var select_default = /*#__PURE__*/__webpack_require__.n(plugin_select);

// EXTERNAL MODULE: ./src/js/plugin/line.js
var line = __webpack_require__("OUnL");
var line_default = /*#__PURE__*/__webpack_require__.n(line);

// EXTERNAL MODULE: ./src/js/plugin/round.js
var round = __webpack_require__("hENp");
var round_default = /*#__PURE__*/__webpack_require__.n(round);

// EXTERNAL MODULE: ./src/js/plugin/rect.js
var rect = __webpack_require__("tjb6");
var rect_default = /*#__PURE__*/__webpack_require__.n(rect);

// EXTERNAL MODULE: ./src/js/plugin/ellipse.js
var ellipse = __webpack_require__("ESOJ");
var ellipse_default = /*#__PURE__*/__webpack_require__.n(ellipse);

// EXTERNAL MODULE: ./src/js/plugin/cut.js
var cut = __webpack_require__("AQzq");
var cut_default = /*#__PURE__*/__webpack_require__.n(cut);

// CONCATENATED MODULE: ./src/js/draw-selection.js
function getPixel(pixelData, x, y) {
  if (x < 0 || y < 0 || x >= pixelData.width || y >= pixelData.height) {
    return NaN;
  }
  var pixels = pixelData.data;
  var i = (y * pixelData.width + x) * 4;
  return [pixels[i + 0], pixels[i + 1], pixels[i + 2], pixels[i + 3]];
}

/*
function setPixel(pixelData, x, y, color) {
    var i = (y * pixelData.width + x) * 4
    var pixels = pixelData.data
    pixels[i + 0] = (color >>> 24) & 0xFF
    //console.log((color >>> 24) & 0xFF)
    pixels[i + 1] = (color >>> 16) & 0xFF
    pixels[i + 2] = (color >>>  8) & 0xFF
    pixels[i + 3] = (color >>>  0) & 0xFF
}
*/
function setPixel(pixelData, x, y, rgba) {
  var i = (y * pixelData.width + x) * 4;
  var pixels = pixelData.data;
  pixels[i + 0] = rgba[0];
  // console.log((color >>> 24) & 0xFF)
  pixels[i + 1] = rgba[1];
  pixels[i + 2] = rgba[2];
  pixels[i + 3] = rgba[3];
}

function diff(c1, c2) {
  /*
  if (isNaN(c1) || isNaN(c2)) {
       return Infinity
   }
   */

  var dr = c1[0] - c2[0];
  var dg = c1[1] - c2[1];
  var db = c1[2] - c2[2];
  var da = c1[3] - c2[3];

  return dr * dr + dg * dg + db * db + da * da;
}

function floodFill(canvas, x, y, replacementColor, delta) {
  var current, w, e, stack, color, cx, cy;
  var context = canvas.getContext('2d');
  var pixelData = context.getImageData(0, 0, canvas.width, canvas.height);
  /*
  console.log(pixelData)
  for (var i = 0; i < 100; i++) {
      for (var j = 0; j < 100; j++) {
          if (i == 0 && j == 0) {
              console.log(getPixel(pixelData, 0, 0))
          }
          setPixel(pixelData, i, j, 0xff0000ff)
      }
   }
  */
  var done = [];
  for (var i = 0; i < canvas.width; i++) {
    done[i] = [];
  }

  var targetColor = getPixel(pixelData, x, y);
  delta *= delta;

  stack = [[x, y]];
  done[x][y] = true;
  while (current = stack.pop()) {
    cx = current[0];
    cy = current[1];

    if (diff(getPixel(pixelData, cx, cy), targetColor) <= delta) {
      setPixel(pixelData, cx, cy, replacementColor);

      w = e = cx;
      while (w > 0 && diff(getPixel(pixelData, w - 1, cy), targetColor) <= delta) {
        --w;
        if (done[w][cy]) break;
        setPixel(pixelData, w, cy, replacementColor);
      }
      while (e < pixelData.width - 1 && diff(getPixel(pixelData, e + 1, cy), targetColor) <= delta) {
        ++e;
        if (done[e][cy]) break;
        setPixel(pixelData, e, cy, replacementColor);
      }

      for (cx = w; cx <= e; cx++) {
        if (cy > 0) {
          color = getPixel(pixelData, cx, cy - 1);
          if (diff(color, targetColor) <= delta) {
            if (!done[cx][cy - 1]) {
              stack.push([cx, cy - 1]);
              done[cx][cy - 1] = true;
            }
          }
        }
        if (cy < canvas.height - 1) {
          color = getPixel(pixelData, cx, cy + 1);
          if (diff(color, targetColor) <= delta) {
            if (!done[cx][cy + 1]) {
              stack.push([cx, cy + 1]);
              done[cx][cy + 1] = true;
            }
          }
        }
      }
    }
  }

  context.putImageData(pixelData, 0, 0, 0, 0, canvas.width, canvas.height);
}

/* harmony default export */ var draw_selection = (floodFill);
// CONCATENATED MODULE: ./src/js/plugin/magicEraser.js
// 魔术橡皮檫工具插件

var magicEraser_DrawBoard = window.DrawBoard;
var magicEraser_typeId = magicEraser_DrawBoard.getTypeId();

magicEraser_DrawBoard.addPlugin({
  type: magicEraser_typeId,
  name: 'magic_eraser',
  init: function init() {
    var that = this;

    that.handlers[magicEraser_typeId] = {
      mousedown: function mousedown(potx, poty) {
        draw_selection(that.layer.canvas, potx, poty, [0, 0, 0, 0], 30);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/js/plugin/paintBucket.js
// 颜料桶工具插件

var paintBucket_DrawBoard = window.DrawBoard;
var Color = window.Color;
var paintBucket_typeId = paintBucket_DrawBoard.getTypeId();

paintBucket_DrawBoard.addPlugin({
  type: paintBucket_typeId,
  name: 'paint_bucket',
  init: function init() {
    var that = this;

    that.handlers[paintBucket_typeId] = {
      mousedown: function mousedown(potx, poty) {
        var color = that.color;
        var rgb = Color.hex2Rbg(color);
        var rgba = [rgb[0], rgb[1], rgb[2], 255];
        draw_selection(that.layer.canvas, potx, poty, rgba, 30);
      },
      mouseup: function mouseup(potx, poty) {
        that.storage();
      }
    };
  }
});
// EXTERNAL MODULE: ./src/js/plugin/pointer.js
var pointer = __webpack_require__("Je60");
var pointer_default = /*#__PURE__*/__webpack_require__.n(pointer);

// EXTERNAL MODULE: ./src/js/plugin/liuye.js
var liuye = __webpack_require__("hmA/");
var liuye_default = /*#__PURE__*/__webpack_require__.n(liuye);

// EXTERNAL MODULE: ./src/js/plugin/hand.js
var hand = __webpack_require__("zZHn");
var hand_default = /*#__PURE__*/__webpack_require__.n(hand);

// EXTERNAL MODULE: ./src/js/plugin/brush.js
var brush = __webpack_require__("DxuS");
var brush_default = /*#__PURE__*/__webpack_require__.n(brush);

// EXTERNAL MODULE: ./src/js/plugin/ink.js
var ink = __webpack_require__("PuVN");
var ink_default = /*#__PURE__*/__webpack_require__.n(ink);

// EXTERNAL MODULE: ./src/js/plugin/text.js
var plugin_text = __webpack_require__("S/9R");
var text_default = /*#__PURE__*/__webpack_require__.n(plugin_text);

// EXTERNAL MODULE: ./src/js/plugin/arrow.js
var arrow = __webpack_require__("aBl8");
var arrow_default = /*#__PURE__*/__webpack_require__.n(arrow);

// CONCATENATED MODULE: ./src/js/draw-plugins.js
/**
 * draw.js 插件，每个插件相互独立
 * Created by cjh1 on 2017/5/1.
 */




















// CONCATENATED MODULE: ./src/js/draw-filter.js

/**
 * draw-filter.js
 * Created by cjh1 on 2016/11/10.
 */
// 滤镜

var draw_filter_DrawBoard = window.DrawBoard;

var gfilter = {
  type: 'canvas',
  name: 'filters',
  author: 'zhigang',
  getInfo: function getInfo() {
    return this.author + ' ' + this.type + ' ' + this.name;
  },

  /**
   * invert color value of pixel, new pixel = RGB(255-r, 255-g, 255 - b)
   *
   * @param binaryData - canvas's imagedata.data
   * @param l - length of data (width * height of image data)
   */
  invert: function invert(context, binaryData, l) {
    for (var x = 0; x < binaryData.width; x++) {
      for (var y = 0; y < binaryData.height; y++) {
        // Index of the pixel in the array
        var idx = (x + y * binaryData.width) * 4;
        var r = binaryData.data[idx + 0];
        var g = binaryData.data[idx + 1];
        var b = binaryData.data[idx + 2];

        // calculate gray scale value
        // var gray = 0.299 * r + 0.587 * g + 0.114 * b

        // assign gray scale value
        binaryData.data[idx + 0] = 255 - r; // Red channel
        binaryData.data[idx + 1] = 255 - g; // Green channel
        binaryData.data[idx + 2] = 255 - b; // Blue channel
      }
    }
  },

  /**
   * adjust color values and make it more darker and gray...
   *
   * @param binaryData
   * @param l
   */
  colorAdjustProcess: function colorAdjustProcess(binaryData, l) {
    for (var i = 0; i < l; i += 4) {
      var r = binaryData[i];
      var g = binaryData[i + 1];
      var b = binaryData[i + 2];

      binaryData[i] = r * 0.272 + g * 0.534 + b * 0.131;
      binaryData[i + 1] = r * 0.349 + g * 0.686 + b * 0.168;
      binaryData[i + 2] = r * 0.393 + g * 0.769 + b * 0.189;
    }
  },

  /**
   * deep clone image data of canvas
   *
   * @param context
   * @param src
   * @returns
   */
  copyImageData: function copyImageData(context, src) {
    var dst = context.createImageData(src.width, src.height);
    dst.data.set(src.data);
    return dst;
  },

  /**
   * convolution - keneral size 5*5 - blur effect filter(模糊效果)
   *
   * @param context
   * @param canvasData
   */
  blur: function blur(context, canvasData) {
    console.log('Canvas Filter - blur process');
    var tempCanvasData = this.copyImageData(context, canvasData);
    var sumred = 0.0;
    var sumgreen = 0.0;
    var sumblue = 0.0;
    for (var x = 0; x < tempCanvasData.width; x++) {
      for (var y = 0; y < tempCanvasData.height; y++) {
        // Index of the pixel in the array
        var idx = (x + y * tempCanvasData.width) * 4;
        for (var subCol = -2; subCol <= 2; subCol++) {
          var colOff = subCol + x;
          if (colOff < 0 || colOff >= tempCanvasData.width) {
            colOff = 0;
          }
          for (var subRow = -2; subRow <= 2; subRow++) {
            var rowOff = subRow + y;
            if (rowOff < 0 || rowOff >= tempCanvasData.height) {
              rowOff = 0;
            }
            var idx2 = (colOff + rowOff * tempCanvasData.width) * 4;
            var r = tempCanvasData.data[idx2 + 0];
            var g = tempCanvasData.data[idx2 + 1];
            var b = tempCanvasData.data[idx2 + 2];
            sumred += r;
            sumgreen += g;
            sumblue += b;
          }
        }

        // calculate new RGB value
        var nr = sumred / 25.0;
        var ng = sumgreen / 25.0;
        var nb = sumblue / 25.0;

        // clear previous for next pixel point
        sumred = 0.0;
        sumgreen = 0.0;
        sumblue = 0.0;

        // assign new pixel value
        canvasData.data[idx + 0] = nr; // Red channel
        canvasData.data[idx + 1] = ng; // Green channel
        canvasData.data[idx + 2] = nb; // Blue channel
        canvasData.data[idx + 3] = 255; // Alpha channel
      }
    }
  },

  /**
   * after pixel value - before pixel value + 128
   * 浮雕效果
   */
  relief: function relief(context, canvasData) {
    console.log('Canvas Filter - relief process');
    var tempCanvasData = this.copyImageData(context, canvasData);
    for (var x = 1; x < tempCanvasData.width - 1; x++) {
      for (var y = 1; y < tempCanvasData.height - 1; y++) {
        // Index of the pixel in the array
        var idx = (x + y * tempCanvasData.width) * 4;
        var bidx = (x - 1 + y * tempCanvasData.width) * 4;
        var aidx = (x + 1 + y * tempCanvasData.width) * 4;

        // calculate new RGB value
        var nr = tempCanvasData.data[aidx + 0] - tempCanvasData.data[bidx + 0] + 128;
        var ng = tempCanvasData.data[aidx + 1] - tempCanvasData.data[bidx + 1] + 128;
        var nb = tempCanvasData.data[aidx + 2] - tempCanvasData.data[bidx + 2] + 128;
        nr = nr < 0 ? 0 : nr > 255 ? 255 : nr;
        ng = ng < 0 ? 0 : ng > 255 ? 255 : ng;
        nb = nb < 0 ? 0 : nb > 255 ? 255 : nb;

        // assign new pixel value
        canvasData.data[idx + 0] = nr; // Red channel
        canvasData.data[idx + 1] = ng; // Green channel
        canvasData.data[idx + 2] = nb; // Blue channel
        canvasData.data[idx + 3] = 255; // Alpha channel
      }
    }
  },

  /**
   *  before pixel value - after pixel value + 128
   *  雕刻效果
   *
   * @param canvasData
   */
  diaokeProcess: function diaokeProcess(context, canvasData) {
    console.log('Canvas Filter - process');
    var tempCanvasData = this.copyImageData(context, canvasData);
    for (var x = 1; x < tempCanvasData.width - 1; x++) {
      for (var y = 1; y < tempCanvasData.height - 1; y++) {
        // Index of the pixel in the array
        var idx = (x + y * tempCanvasData.width) * 4;
        var bidx = (x - 1 + y * tempCanvasData.width) * 4;
        var aidx = (x + 1 + y * tempCanvasData.width) * 4;

        // calculate new RGB value
        var nr = tempCanvasData.data[bidx + 0] - tempCanvasData.data[aidx + 0] + 128;
        var ng = tempCanvasData.data[bidx + 1] - tempCanvasData.data[aidx + 1] + 128;
        var nb = tempCanvasData.data[bidx + 2] - tempCanvasData.data[aidx + 2] + 128;
        nr = nr < 0 ? 0 : nr > 255 ? 255 : nr;
        ng = ng < 0 ? 0 : ng > 255 ? 255 : ng;
        nb = nb < 0 ? 0 : nb > 255 ? 255 : nb;

        // assign new pixel value
        canvasData.data[idx + 0] = nr; // Red channel
        canvasData.data[idx + 1] = ng; // Green channel
        canvasData.data[idx + 2] = nb; // Blue channel
        canvasData.data[idx + 3] = 255; // Alpha channel
      }
    }
  },

  /**
   * mirror reflect flipv
   *
   * @param context
   * @param canvasData
   */
  mirror: function mirror(context, canvasData) {
    console.log('Canvas Filter - process');
    var tempCanvasData = this.copyImageData(context, canvasData);
    for (var x = 0; x < tempCanvasData.width; x++) {
      for (var y = 0; y < tempCanvasData.height; y++) {
        // Index of the pixel in the array
        var idx = (x + y * tempCanvasData.width) * 4;
        var midx = (tempCanvasData.width - 1 - x + y * tempCanvasData.width) * 4;

        // assign new pixel value
        canvasData.data[midx + 0] = tempCanvasData.data[idx + 0]; // Red channel
        canvasData.data[midx + 1] = tempCanvasData.data[idx + 1]; // Green channel
        canvasData.data[midx + 2] = tempCanvasData.data[idx + 2]; // Blue channel
        canvasData.data[midx + 3] = 255; // Alpha channel
      }
    }
  },
  fliph: function fliph(context, canvasData) {
    console.log('Canvas Filter - process');
    var tempCanvasData = this.copyImageData(context, canvasData);
    for (var x = 0; x < tempCanvasData.width; x++) {
      for (var y = 0; y < tempCanvasData.height; y++) {
        // Index of the pixel in the array
        var idx = (x + y * tempCanvasData.width) * 4;
        var midx = ((tempCanvasData.height - y - 1) * tempCanvasData.width + x) * 4;

        // assign new pixel value
        canvasData.data[midx + 0] = tempCanvasData.data[idx + 0]; // Red channel
        canvasData.data[midx + 1] = tempCanvasData.data[idx + 1]; // Green channel
        canvasData.data[midx + 2] = tempCanvasData.data[idx + 2]; // Blue channel
        canvasData.data[midx + 3] = 255; // Alpha channel
      }
    }
  },
  // 通用简单滤镜
  simpleFiler: function simpleFiler(binaryData, handler) {
    var start = new Date().getTime();
    for (var x = 0; x < binaryData.width; x++) {
      for (var y = 0; y < binaryData.height; y++) {
        // Index of the pixel in the array
        var idx = (x + y * binaryData.width) * 4;
        var r = binaryData.data[idx + 0];
        var g = binaryData.data[idx + 1];
        var b = binaryData.data[idx + 2];
        var a = binaryData.data[idx + 3];

        var arr = handler(r, g, b, a);
        binaryData.data[idx + 0] = arr[0]; // Red channel
        binaryData.data[idx + 1] = arr[1]; // Green channel
        binaryData.data[idx + 2] = arr[2]; // Blue channel
        binaryData.data[idx + 3] = arr[3]; // Blue channel
      }
    }
    console.log(new Date().getTime() - start + 'ms');
  },
  gray: function gray(context, binaryData) {
    this.simpleFiler(binaryData, function (r, g, b, a) {
      var gray = 0.299 * r + 0.587 * g + 0.114 * b;
      return [gray, gray, gray, a];
    });
  },
  // 明度
  grayLigtness: function grayLigtness(context, binaryData, l) {
    this.simpleFiler(binaryData, function (r, g, b, a) {
      var val = parseInt((Math.max(r, g, b) + Math.min(r, g, b)) * 0.5);
      return [val, val, val, a];
    });
  },
  // 亮度
  grayLuminosity: function grayLuminosity(context, binaryData, l) {
    this.simpleFiler(binaryData, function (r, g, b, a) {
      var val = parseInt(r * 0.21) + g * 0.71 + b * 0.07;
      return [val, val, val, val, a];
    });
  },
  // 平均亮度
  grayLuminosity2: function grayLuminosity2(context, binaryData, l) {
    this.simpleFiler(binaryData, function (r, g, b, a) {
      var val = parseInt((r + g + b) / 3.0);
      return [val, val, val, a];
    });
  },
  // 棕褐色灰度图sepia
  sepiaTone: function sepiaTone(context, binaryData, l) {
    this.simpleFiler(binaryData, function (r, g, b, a) {
      var rs = r * 0.393 + g * 0.769 + b * 0.189;
      var gs = r * 0.349 + g * 0.686 + b * 0.168;
      var bs = r * 0.272 + g * 0.534 + b * 0.131;
      return [rs > 255 ? 255 : parseInt(rs), gs > 255 ? 255 : parseInt(gs), bs > 255 ? 255 : parseInt(bs), a];
    });
  },
  // 滤镜,修改颜色通道的顺序,例如:order=[2,0,1,3]
  swapChannels: function swapChannels(context, binaryData, l) {
    this.simpleFiler(binaryData, function (r, g, b, a) {
      var rgba = [r, g, b, a];
      var order = [2, 0, 1, 3]; // TODO 这里写死了
      return [rgba[order[0]], rgba[order[1]], rgba[order[2]], rgba[order[3]]];
    });
  },
  // 起始像素的灰度作为alpha值,将每个像素的RGB设为特定颜色,第四个参数被定时为期望颜色的RGB值数组-
  // 例如:color=[0,0,255]为蓝色,[0,0,0]灰色
  monoColor: function monoColor(context, binaryData, l) {
    this.simpleFiler(binaryData, function (r, g, b, a) {
      var color = [0, 0, 255]; // TODO 这里写死
      return [color[0], color[1], color[2], 255 - parseInt(r + g + b) / 3];
    });
  },
  // 正片叠底 C=(A*B)/255
  multiply: function multiply(context, binaryData, binaryData2) {
    for (var x = 0; x < binaryData.width; x++) {
      for (var y = 0; y < binaryData.height; y++) {
        // Index of the pixel in the array
        var idx = (x + y * binaryData.width) * 4;
        var r = binaryData.data[idx + 0];
        var g = binaryData.data[idx + 1];
        var b = binaryData.data[idx + 2];
        var a = binaryData.data[idx + 3];

        var r2 = binaryData2.data[idx + 0];
        var g2 = binaryData2.data[idx + 1];
        var b2 = binaryData2.data[idx + 2];
        // var a2 = binaryData2.data[idx + 3]

        var arr = [r * r2 / 255, g * g2 / 255, b * b2 / 255, a];

        binaryData.data[idx + 0] = arr[0]; // Red channel
        binaryData.data[idx + 1] = arr[1]; // Green channel
        binaryData.data[idx + 2] = arr[2]; // Blue channel
        binaryData.data[idx + 3] = arr[3]; // Blue channel
      }
    }
  },
  // 颜色加深 C=A-((255-A)*(255-B)/B)
  colorBurn: function colorBurn(context, binaryData, l) {
    this.simpleFiler(binaryData, function (r, g, b, a) {
      return [r - (255 - r) * (255 - r) / r, g - (255 - g) * (255 - g) / g, b - (255 - b) * (255 - b) / b, a];
    });
  },
  // 线性减淡
  linearDodge: function linearDodge(context, binaryData, l) {
    function cal(a, b) {
      return a + b;
    }

    this.simpleFiler(binaryData, function (r, g, b, a) {
      return [cal(r, r), cal(g, g), cal(b, b), a];
    });
  },
  // 柔光
  softLight: function softLight(context, binaryData, l) {
    function cal(a, b) {
      if (b <= 128) {
        return a * b / 128 + a / 255 * (a / 255) * (255 - 2 * b);
      } else {
        return a * (255 - b) / 128 + Math.sqrt(a / 255) * (2 * b - 255);
      }
    }

    this.simpleFiler(binaryData, function (r, g, b, a) {
      return [cal(r, r), cal(g, g), cal(b, b), a];
    });
  },
  // 差值
  difference: function difference(context, binaryData, l) {
    function cal(a, b) {
      return Math.abs(a - b);
    }

    this.simpleFiler(binaryData, function (r, g, b, a) {
      return [cal(r, r), cal(g, g), cal(b, b), a];
    });
  },
  // 溶解
  dissolve: function dissolve(context, binaryData, l) {
    this.simpleFiler(binaryData, function (r, g, b, a) {
      if (Math.random() < 0.1) {
        return [255, 255, 255, 0];
      } else {
        return [r, g, b, a];
      }
    });
  },
  // 马赛克
  mosaic: function mosaic(context, binaryData) {
    var options = {
      blockSize: 8
    };

    var width = binaryData.width;
    var height = binaryData.height;

    var blockSize = clamp(options.blockSize, 1, Math.max(width, height));
    var yBlocks = Math.ceil(height / blockSize);
    var xBlocks = Math.ceil(width / blockSize);
    var y1 = void 0;
    var x1 = void 0;
    var idx = void 0;
    var pidx = void 0;

    for (var i = 0, y0 = 0, bidx = 0; i < yBlocks; i++) {
      y1 = clamp(y0 + blockSize, 0, height);
      for (var j = 0, x0 = 0; j < xBlocks; j++, bidx++) {
        x1 = clamp(x0 + blockSize, 0, width);

        idx = y0 * width + x0 << 2;
        var r = binaryData[idx];
        var g = binaryData[idx + 1];
        var b = binaryData[idx + 2];

        for (var bi = y0; bi < y1; bi++) {
          for (var bj = x0; bj < x1; bj++) {
            pidx = bi * width + bj << 2;
            binaryData[pidx] = r;
            binaryData[pidx + 1] = g;
            binaryData[pidx + 2] = b;
            binaryData[pidx + 3] = binaryData[pidx + 3];
          }
        }
        x0 = x1;
      }
      y0 = y1;
    }
  }

  // 滤镜和调整
};draw_filter_DrawBoard.fn.filter = function (name) {
  var that = this;
  var canvas = that.layer.canvas;
  var context = canvas.getContext('2d');
  var canvasData = context.getImageData(0, 0, canvas.width, canvas.height);
  gfilter[name](context, canvasData);
  context.putImageData(canvasData, 0, 0);

  that.storage();
};

// 混合模式
draw_filter_DrawBoard.fn.filter2 = function (name) {
  var that = this;
  var canvas = that.layer.canvas;
  var context = canvas.getContext('2d');
  var canvasData = that.layers[0].ctx.getImageData(0, 0, canvas.width, canvas.height);
  var canvasData2 = that.layers[1].ctx.getImageData(0, 0, canvas.width, canvas.height);
  gfilter[name](context, canvasData, canvasData2);
  context.putImageData(canvasData, 0, 0);

  that.storage();
};
// EXTERNAL MODULE: ./src/js/draw-pen.js
var draw_pen = __webpack_require__("psEl");
var draw_pen_default = /*#__PURE__*/__webpack_require__.n(draw_pen);

// CONCATENATED MODULE: ./src/js/draw.js

// import './draw-selection'



// EXTERNAL MODULE: ./src/js/index.js
var js = __webpack_require__("vGYV");
var js_default = /*#__PURE__*/__webpack_require__.n(js);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.4@babel-loader/lib!./node_modules/_vue-loader@13.7.1@vue-loader/lib/selector.js?type=script&index=0!./src/components/page/page.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var page = ({
    data: function data() {
        return {
            open: false,
            docked: true
        };
    },

    props: {
        title: {
            type: String,
            default: ''
        },
        name: {
            type: String,
            default: 'default'
        },
        page: {
            type: Object,
            default: function _default() {
                return {
                    title: '云设'
                };
            }
        },
        backable: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        toggle: function toggle() {
            console.log(this.$refs.page);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.1@vue-loader/lib/template-compiler?{"id":"data-v-9d943f58","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.1@vue-loader/lib/selector.js?type=template&index=0!./src/components/page/page.vue
var page_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-page',{ref:"page",attrs:{"title":_vm.title || _vm.page.title,"page":_vm.page,"backable":_vm.backable}},[_c('div',{attrs:{"slot":"drawer"},slot:"drawer"},[_c('ui-appbar',{attrs:{"title":""}}),_vm._v(" "),_c('ui-list',{on:{"itemClick":function($event){_vm.toggle()}}},[_c('ui-list-item',{attrs:{"title":"关于","to":"/about"}},[_c('ui-icon',{attrs:{"slot":"left","value":"grade"},slot:"left"})],1)],1)],1),_vm._v(" "),_vm._t("default")],2)}
var page_staticRenderFns = []
var page_esExports = { render: page_render, staticRenderFns: page_staticRenderFns }
/* harmony default export */ var page_page = (page_esExports);
// CONCATENATED MODULE: ./src/components/page/page.vue
function page_injectStyle (ssrContext) {
  __webpack_require__("9z10")
}
var page_normalizeComponent = __webpack_require__("Z0/y")
/* script */


/* template */

/* template functional */
var page___vue_template_functional__ = false
/* styles */
var page___vue_styles__ = page_injectStyle
/* scopeId */
var page___vue_scopeId__ = "data-v-9d943f58"
/* moduleIdentifier (server only) */
var page___vue_module_identifier__ = null
var page_Component = page_normalizeComponent(
  page,
  page_page,
  page___vue_template_functional__,
  page___vue_styles__,
  page___vue_scopeId__,
  page___vue_module_identifier__
)

/* harmony default export */ var components_page_page = (page_Component.exports);

// CONCATENATED MODULE: ./src/components/page/index.js

// CONCATENATED MODULE: ./src/components/index.js


/* harmony default export */ var components = ({
    install: function install(Vue) {
        Vue.component('my-page', components_page_page);
    }
});
// EXTERNAL MODULE: ./src/scss/main.scss
var main = __webpack_require__("hvFc");
var main_default = /*#__PURE__*/__webpack_require__.n(main);

// CONCATENATED MODULE: ./src/main.js







external__Vue__default.a.use(components);

external__Vue__default.a.config.productionTip = false;

// Vue.prototype.$storage = storage

external__Vue__default.a.config.productionTip = false;

/* eslint-disable no-new */
new external__Vue__default.a({
    el: '#app',
    router: router,
    template: '<App/>',
    components: { App: src_App }
});

/***/ }),

/***/ "OUnL":
/***/ (function(module, exports) {

// 直线插件
var DrawBoard = window.DrawBoard;

var typeId = DrawBoard.getTypeId();

DrawBoard.addPlugin({
    type: typeId,
    name: 'line',
    init: function init() {
        var _this = this;

        this.handlers[typeId] = {
            select: function select() {
                _this.ctx.strokeStyle = _this.color;
            },
            mousemove: function mousemove(potx, poty) {
                if (_this.isDown) {
                    _this.newx = potx;
                    _this.newy = poty;

                    _this.ctx2.clearRect(0, 0, _this.width, _this.height);
                    _this.layer2.drawLine(_this.oldx, _this.oldy, _this.newx, _this.newy);
                }
            },
            mousedown: function mousedown(potx, poty) {
                _this.layer2.show();
            },
            mouseup: function mouseup(potx, poty) {
                _this.layer2.clearRect();
                _this.layer.drawLine(_this.oldx, _this.oldy, _this.newx, _this.newy);
                _this.storage();
            }
        };
    }
});

/***/ }),

/***/ "PuVN":
/***/ (function(module, exports) {

// 墨水笔插件
/* eslint-disable */
(function ($) {
    var typeId = DrawBoard.getTypeId();

    var linex = [];
    var liney = [];

    var $elemMenu = $('#pencil-dialog');

    DrawBoard.addPlugin({
        type: typeId,
        name: 'ink',
        init: function init() {
            var that = this;

            that.handlers[typeId] = {
                select: function select() {
                    that.ctx.strokeStyle = that.color;
                },
                mousemove: function mousemove(potx, poty) {
                    if (that.isDown) {
                        that.newx = potx;
                        that.newy = poty;

                        that.size = 8;
                        var s = Math.ceil(that.size / 2); //算出粒子的单位长度
                        var vlength = Math.sqrt((that.oldx - that.newx) * (that.oldx - that.newx) + (that.oldy - that.newy) * (that.oldy - that.newy));
                        var stepNum = Math.floor(vlength / s) + 1; //算出步长  vlength为斜线长度


                        that._latestStrokeLength = vlength;

                        var INK_AMOUNT = 15; // 画笔的粒子数量，控制笔划的浓密程度

                        var sep = 1.5; // 分割数  控制画笔的浓密程度  关键所在
                        //粒子的大小 根据画笔描绘的速度（画笔的停留时间）进行调整
                        var dotSize = sep * Math.min(INK_AMOUNT / that._latestStrokeLength * 3, 1);
                        var dotNum = Math.ceil(that.size * sep);
                        var range = that.size / 2;
                        var i, j, r, c, x, y;

                        that.ctx.save();

                        //log(currentColor);//获取当前颜色值

                        that.ctx.beginPath();

                        var nx = (that.newx - that.oldx) / vlength * s;
                        var ny = (that.newy - that.oldy) / vlength * s;

                        // 如果间距过大，补充过度点
                        if (vlength > that.lineWidth) {
                            var num = vlength / that.lineWidth * 3;
                            var x, y;
                            for (var i = 0; i < num - 1; i++) {
                                x = that.oldx + (potx - that.oldx) / num * (i + 1);
                                y = that.oldy + (poty - that.oldy) / num * (i + 1);
                                that.ctx.arc(x, y, that.lineWidth / 2, 0, Math.PI * 2, true);
                            }
                        }
                        // 画最后一点
                        that.ctx.arc(potx, poty, that.lineWidth / 2, 0, Math.PI * 2, true);
                        that.ctx.fill();

                        that.oldx = that.newx;
                        that.oldy = that.newy;
                    }
                    //that.cursorLayer.ctx.strokeStyle = that.color
                    that.cursorLayer.ctx.strokeStyle = '#999';
                    that.cursorLayer.ctx.clearRect(0, 0, that.width, that.height);
                    that.cursorLayer.drawRound(x, y, that.lineWidth / 2, false);
                    that.cursorLayer.ctx.strokeStyle = '#999';
                    that.cursorLayer.drawLine(x - 4, y, x + 4, y);
                    that.cursorLayer.drawLine(x, y - 4, x, y + 4);
                },
                mouseup: function mouseup(potx, poty) {
                    that.storage();
                }
            };
        }
    });
})(jQuery);

/***/ }),

/***/ "S/9R":
/***/ (function(module, exports) {

/* eslint-disable */

// 文字插件
(function ($) {
    var typeId = DrawBoard.getTypeId();

    var downX;
    var downY;
    var editing = false;

    DrawBoard.addPlugin({
        type: typeId,
        name: 'text',
        init: function init() {
            var that = this;

            that.handlers[typeId] = {
                select: function select() {
                    /*that.ctx.strokeStyle = that.color
                     //that.ctx.strokeStyle = 'rgba(0,0,0,.5)'
                       that.cursorLayer.ctx.fillStyle = "#999999"
                     that.cursorLayer.ctx.strokeStyle = that.color
                     that.cursorLayer.ctx.lineWidth = 1
                     that.$elem.css('cursor', 'none');*/
                },
                unselect: function unselect() {
                    that.ctx.strokeStyle = 'rgba(250,250,250,1)';
                    that.$elem.css('cursor', 'default');
                },
                click: function click(potx, poty) {
                    if (!editing) {
                        editing = true;
                        var $textBox = $('#text-box');
                        $textBox.show();
                        $textBox.css({
                            left: potx + that.offsetX - 8,
                            top: poty + that.offsetY - 8
                        });
                        $('#text-box-input').focus().val('');
                        $('#text-box-input').one('blur', function () {
                            editing = false;
                            $textBox.hide();
                            var text = this.value;
                            if (text) {
                                that.ctx.font = "18px '宋体'";
                                that.ctx.fillText(text, potx, poty);
                            }
                        });
                    }
                },
                mousedown: function mousedown(potx, poty) {
                    downX = potx;
                    downY = poty;
                },
                mousemove: function mousemove(x, y) {
                    if (that.isDown) {
                        var elem = document.getElementById('drawboard');
                        elem.scrollTop = downY - y;
                        //elem.scrollLeft = x - downX
                    }
                },
                mouseup: function mouseup(potx, poty) {
                    that.storage();
                }
            };
        }
    });
})(jQuery);

/***/ }),

/***/ "aBl8":
/***/ (function(module, exports) {

// 箭头插件
var DrawBoard = window.DrawBoard;
var typeId = DrawBoard.getTypeId();

// 画箭头
function drawArrow(ctx, x1, y1, x2, y2) {
    var sta = [0, 0];
    var end = [x2 - x1, y1 - y2];

    var con = ctx;
    con.save();
    con.translate(x1, y1); // 坐标源点

    con.beginPath();
    con.moveTo(sta[0], 0 - sta[1]);
    con.lineTo(end[0], 0 - end[1]);
    con.stroke();

    con.translate(end[0], 0 - end[1]);
    if (end[1] - sta[1] >= 0) {
        con.rotate(Math.atan((end[0] - sta[0]) / (end[1] - sta[1])));
    } else {
        con.rotate(Math.PI + Math.atan((end[0] - sta[0]) / (end[1] - sta[1]))); // 旋转弧度
    }
    con.moveTo(-5, 10);
    con.lineTo(0, 5);
    con.lineTo(5, 10);
    con.lineTo(0, 0);
    con.fill();
    con.restore();
}

DrawBoard.addPlugin({
    type: typeId,
    name: 'arrow',
    init: function init() {
        var that = this;
        that.handlers[typeId] = {
            select: function select() {
                that.ctx.strokeStyle = that.color;
            },
            mousemove: function mousemove(potx, poty) {
                if (that.isDown) {
                    that.newx = potx;
                    that.newy = poty;

                    that.ctx2.clearRect(0, 0, that.width, that.height);
                    drawArrow(that.ctx2, that.oldx, that.oldy, that.newx, that.newy);
                }
            },
            mousedown: function mousedown(potx, poty) {
                that.layer2.show();
            },
            mouseup: function mouseup(potx, poty) {
                that.layer2.clearRect();

                drawArrow(that.ctx, that.oldx, that.oldy, that.newx, that.newy);
                // that.layer.drawLine(that.oldx, that.oldy, that.newx, that.newy)
                that.storage();
            }
        };
    }
});

/***/ }),

/***/ "hENp":
/***/ (function(module, exports) {

// 圆形插件
var DrawBoard = window.DrawBoard;

var typeId = DrawBoard.getTypeId();

DrawBoard.addPlugin({
    type: typeId,
    name: 'round',
    init: function init() {
        var that = this;

        that.handlers[typeId] = {
            select: function select() {
                that.ctx.strokeStyle = that.color;
            },
            mousedown: function mousedown(potx, poty) {
                that.layer2.show();
            },
            mousemove: function mousemove(potx, poty) {
                if (that.isDown) {
                    that.newx = potx;
                    that.newy = poty;

                    that.ctx2.clearRect(0, 0, that.width, that.height);
                    var radius = Math.sqrt((that.oldx - that.newx) * (that.oldx - that.newx) + (that.oldy - that.newy) * (that.oldy - that.newy));
                    that.layer2.drawRound(that.oldx, that.oldy, radius);
                }
            },
            mouseup: function mouseup(potx, poty) {
                that.layer2.clearRect();

                var newx = potx;
                var newy = poty;

                var radius = Math.sqrt((that.oldx - newx) * (that.oldx - newx) + (that.oldy - newy) * (that.oldy - newy));
                that.layer.drawRound(that.oldx, that.oldy, radius);
                that.storage();
            }
        };
    }
});

/***/ }),

/***/ "hmA/":
/***/ (function(module, exports) {

// 柳叶笔插件

var DrawBoard = window.DrawBoard;
var Color = window.Color;
var context = window.context; // TODO
var $elemMenu = window.$elemMenu; // TODO

var typeId = DrawBoard.getTypeId();

var linex = [];
var liney = [];

DrawBoard.addPlugin({
  type: typeId,
  name: 'liuye',
  init: function init() {
    var that = this;
    that.handlers[typeId] = {
      select: function select() {
        that.ctx.strokeStyle = that.color;

        that.cursorLayer.ctx.fillStyle = '#999999';
        that.cursorLayer.ctx.strokeStyle = that.color;
        that.cursorLayer.ctx.lineWidth = 1;
        that.$elem.css('cursor', 'none');
      },
      unselect: function unselect() {
        that.ctx.strokeStyle = 'rgba(250,250,250,1)';
        that.$elem.css('cursor', 'default');
      },
      mousedown: function mousedown(potx, poty) {
        linex.push(potx);
        liney.push(poty);

        that.ctx2.beginPath();
        that.ctx2.moveTo(potx, poty);
      },
      mouseout: function mouseout(potx, poty) {
        that.cursorLayer.ctx.clearRect(0, 0, that.width, that.height);
      },
      mousemove: function mousemove(x, y) {
        if (that.isDown) {
          linex.push(x);
          liney.push(y);
          that.ctx2.lineTo(x, y);

          that.ctx2.lineCap = 'round';
          that.ctx2.lineJoin = 'round';
          that.ctx2.lineWidth = that.lineWidth;
          var rgb = Color.hex2Rbg(that.color);
          var rgba = 'rgba(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ',' + that.opacity + ')';
          that.ctx2.fillStyle = rgba;

          that.ctx2.clearRect(0, 0, that.width, that.height);
          that.ctx2.beginPath();
          for (var i = 0; i < linex.length; i++) {
            if (i === 0) {
              that.ctx2.moveTo(linex[i], liney[i]);
            } else {
              that.ctx2.lineTo(linex[i], liney[i]);
            }
          }
          that.ctx2.fill();

          /*
          that.ctx2.strokeStyle = "rgba(254,0,0,1)"
              that.ctx2.globalCompositeOperation="destination-out"
              that.ctx2.stroke()
              */

          /*
          that.ctx2.strokeStyle = rgba
              that.ctx2.globalCompositeOperation="source-over"
              that.ctx2.stroke()
              */
        }

        // that.cursorLayer.ctx.strokeStyle = that.color
        that.cursorLayer.ctx.strokeStyle = '#999';

        that.cursorLayer.ctx.clearRect(0, 0, that.width, that.height);
        that.cursorLayer.ctx.strokeStyle = '#999';
        that.cursorLayer.drawLine(x - 4, y, x + 4, y);
        that.cursorLayer.drawLine(x, y - 4, x, y + 4);
      },
      mouseup: function mouseup(potx, poty) {
        that.ctx2.clearRect(0, 0, that.width, that.height);

        if (linex.length > 0) {
          var x = linex[0];
          var y = liney[0];
          that.ctx.beginPath();
          that.ctx.moveTo(x, y);

          for (var i = 1; i < linex.length; i++) {
            x = linex[i];
            y = liney[i];
            that.ctx.lineTo(x, y);
          }
          linex.length = 0;
          liney.length = 0;

          that.ctx.lineCap = 'round';
          that.ctx.lineJoin = 'round';
          that.ctx.lineWidth = that.lineWidth;
          var rgb = Color.hex2Rbg(that.color);
          var rgba = 'rgba(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ',' + that.opacity + ')';
          that.ctx.strokeStyle = rgba;
          that.ctx.fill();
        }
        that.storage();
      },
      contextmenu: function contextmenu(potx, poty, e) {
        context($elemMenu, e);
      }
    };
  }
});

/***/ }),

/***/ "hvFc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lRwf":
/***/ (function(module, exports) {

module.exports = Vue;

/***/ }),

/***/ "pRNm":
/***/ (function(module, exports) {

module.exports = VueRouter;

/***/ }),

/***/ "psEl":
/***/ (function(module, exports) {

/* eslint-disable */

// https://github.com/jareguo/curve-editor
// 钢笔插件
(function ($) {
    var typeId = DrawBoard.getTypeId();

    DrawBoard.addPlugin({
        type: typeId,
        name: 'pen',
        init: function init() {
            var that = this;

            function v2(x, y) {
                return {
                    x: x || 0,
                    y: y || 0
                };
            }
            v2.add = function (lhs, rhs) {
                return v2(lhs.x + rhs.x, lhs.y + rhs.y);
            };
            v2.sub = function (lhs, rhs) {
                return v2(lhs.x - rhs.x, lhs.y - rhs.y);
            };
            v2.mul = function (v, scaling) {
                return v2(v.x * scaling, v.y * scaling);
            };
            v2.div = function (v, scaling) {
                return v2(v.x / scaling, v.y / scaling);
            };
            v2.lerp = function (from, to, ratio) {
                return v2(from.x + (to.x - from.x) * ratio, from.y + (to.y - from.y) * ratio);
            };
            v2.sqrDistance = function (lhs, rhs) {
                var dx = lhs.x - rhs.x;
                var dy = lhs.y - rhs.y;
                return dx * dx + dy * dy;
            };
            v2.distance = function (lhs, rhs) {
                return Math.sqrt(v2.sqrDistance(lhs, rhs));
            };
            v2.dir = function (lhs, rhs) {
                var len = v2.distance(v2, { x: 0, y: 0 });
                return v2(v2.x / len, v2.y / len);
            };

            function Curve(points) {
                this.points = points || [];
                this.beziers = [];
                this.ratios = [];
                this.progresses = [];

                this.length = 0;

                this.computeBeziers();
            }

            Curve.prototype.computeBeziers = function () {
                this.beziers.length = 0;
                this.ratios.length = 0;
                this.progresses.length = 0;
                this.length = 0;

                for (var i = 1; i < this.points.length; i++) {
                    var startPoint = this.points[i - 1];
                    var endPoint = this.points[i];
                    var bezier = new Bezier();
                    bezier.start = startPoint.pos;
                    bezier.startCtrlPoint = startPoint.out;
                    bezier.end = endPoint.pos;
                    bezier.endCtrlPoint = endPoint.in;
                    this.beziers.push(bezier);

                    this.length += bezier.getLength();
                }

                var current = 0;
                for (var i = 0; i < this.beziers.length; i++) {
                    var bezier = this.beziers[i];
                    this.ratios[i] = bezier.getLength() / this.length;
                    this.progresses[i] = current = current + this.ratios[i];
                }

                return this.beziers;
            };

            function Bezier() {
                this.start = v2();
                this.end = v2();
                this.startCtrlPoint = v2(); // cp0, cp1
                this.endCtrlPoint = v2(); // cp2, cp3
            }

            // Get point at relative position in curve according to arc length
            // - u [0 .. 1]
            Bezier.prototype.getPointAt = function (u) {
                var t = this.getUtoTmapping(u);
                return this.getPoint(t);
            };

            function bezierAt(C1, C2, C3, C4, t) {
                var t1 = 1 - t;
                return C1 * t1 * t1 * t1 + C2 * 3 * t1 * t1 * t + C3 * 3 * t1 * t * t + C4 * t * t * t;
            }

            // Get point at time t
            //  - t [0 .. 1]
            Bezier.prototype.getPoint = function (t) {
                var x = bezierAt(this.start.x, this.startCtrlPoint.x, this.endCtrlPoint.x, this.end.x, t);
                var y = bezierAt(this.start.y, this.startCtrlPoint.y, this.endCtrlPoint.y, this.end.y, t);

                return new v2(x, y);
            };

            // Get total curve arc length
            Bezier.prototype.getLength = function () {

                var lengths = this.getLengths();
                return lengths[lengths.length - 1];
            };

            // Get list of cumulative segment lengths
            Bezier.prototype.getLengths = function (divisions) {

                if (!divisions) divisions = this.__arcLengthDivisions ? this.__arcLengthDivisions : 200;

                if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1) {

                    //console.log( "cached", this.cacheArcLengths );
                    return this.cacheArcLengths;
                }

                var cache = [];
                var current,
                    last = this.getPoint(0);
                var p,
                    sum = 0;

                cache.push(0);

                for (p = 1; p <= divisions; p++) {

                    current = this.getPoint(p / divisions);
                    sum += v2.distance(current, last);
                    cache.push(sum);
                    last = current;
                }

                this.cacheArcLengths = cache;

                return cache; // { sums: cache, sum:sum }; Sum is in the last element.
            };

            Bezier.prototype.getUtoTmapping = function (u, distance) {

                var arcLengths = this.getLengths();

                var i = 0,
                    il = arcLengths.length;

                var targetArcLength; // The targeted u distance value to get

                if (distance) {
                    targetArcLength = distance;
                } else {
                    targetArcLength = u * arcLengths[il - 1];
                }

                //var time = Date.now();

                // binary search for the index with largest value smaller than target u distance

                var low = 0,
                    high = il - 1,
                    comparison;

                while (low <= high) {

                    i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats

                    comparison = arcLengths[i] - targetArcLength;

                    if (comparison < 0) {

                        low = i + 1;
                        continue;
                    } else if (comparison > 0) {

                        high = i - 1;
                        continue;
                    } else {

                        high = i;
                        break;

                        // DONE
                    }
                }

                i = high;

                //console.log('b' , i, low, high, Date.now()- time);

                if (arcLengths[i] == targetArcLength) {

                    var t = i / (il - 1);
                    return t;
                }

                // we could get finer grain at lengths, or use simple interpolatation between two points

                var lengthBefore = arcLengths[i];
                var lengthAfter = arcLengths[i + 1];

                var segmentLength = lengthAfter - lengthBefore;

                // determine where we are between the 'before' and 'after' points

                var segmentFraction = (targetArcLength - lengthBefore) / segmentLength;

                // add that fractional amount to t

                var t = (i + segmentFraction) / (il - 1);

                return t;
            };

            // RENDERING
            function drawPoint(pos, strokeColor, fillColor, radius) {
                var radius = radius || 5;
                ctx.lineWidth = 1;
                ctx.strokeStyle = strokeColor;
                ctx.fillStyle = fillColor;
                ctx.beginPath();
                ctx.arc(pos.x, pos.y, radius, 0, Math.PI * 2, true);
                ctx.fill();
                ctx.stroke();
            }

            function drawLine(from, to) {
                ctx.lineWidth = 1;
                ctx.strokeStyle = "#000";
                ctx.beginPath();
                ctx.moveTo(from.x, from.y);
                ctx.lineTo(to.x, to.y);
                ctx.stroke();
            }

            function getBezierPos(bezier, progress) {
                var p01 = v2.lerp(bezier.start, bezier.startCtrlPoint, progress);
                var p12 = v2.lerp(bezier.startCtrlPoint, bezier.endCtrlPoint, progress);
                var p23 = v2.lerp(bezier.endCtrlPoint, bezier.end, progress);
                var p012 = v2.lerp(p01, p12, progress);
                var p123 = v2.lerp(p12, p23, progress);
                var p0123 = v2.lerp(p012, p123, progress);
                return p0123;
            }

            /*function drawCanvas (Speed) {
                 drawCanvas2(Speed);
            }*/
            function drawCanvas(Speed) {
                ctx.clearRect(0, 0, canvas.width, canvas.height);

                // 绘制锚点和控制点
                var bezierProgress = 0;
                var bezierIndex = 0;

                if (false) {
                    while (bezierProgress < 1) {
                        bezierProgress += Speed;
                        if (bezierProgress > curve.progresses[bezierIndex]) {
                            bezierIndex++;
                            bezierIndex %= curve.beziers.length;
                        }

                        var realProgress = (bezierProgress - (bezierIndex > 0 ? curve.progresses[bezierIndex - 1] : 0)) / curve.ratios[bezierIndex];

                        var pos = curve.beziers[bezierIndex].getPointAt(realProgress);
                        drawPoint(pos, CurveColor, CurveColor, 1);
                    }
                } else {
                    drawPath();
                }

                // 画虚线
                var CurvePointStrokeColor = "#000";
                var ControlPointStrokeColor = "#090";
                var PointFillColor = "rgba(200,200,200,0.5)";
                var CurveColor = "#44F";

                // curve points
                for (var i = 0; i < curve.points.length; i++) {
                    var point = curve.points[i];
                    drawPoint(point.pos, CurvePointStrokeColor, PointFillColor);
                    if (point.in) {
                        drawPoint(point.in, CurvePointStrokeColor, PointFillColor);
                        drawLine(point.pos, point.in);
                    }

                    if (point.out) {
                        drawPoint(point.out, CurvePointStrokeColor, PointFillColor);
                        drawLine(point.pos, point.out);
                    }
                }
                console.log(curve.beziers.length);
                for (var i = 0; i < curve.beziers.length; i++) {
                    // control points
                    //drawPoint(bezier.startCtrlPoint, ControlPointStrokeColor, PointFillColor);
                    //drawPoint(bezier.endCtrlPoint, ControlPointStrokeColor, PointFillColor);
                    //drawLine(bezier.start, bezier.startCtrlPoint);
                    //drawLine(bezier.end, bezier.endCtrlPoint);
                }
            }

            // 画贝塞尔曲线
            function drawPath() {
                console.log(curve.points.length);
                for (var i = 0; i < curve.points.length; i++) {
                    var point = curve.points[i];
                    console.log(point);
                    if (i == 0) {
                        ctx.moveTo(point.pos.x, point.pos.y);
                    } else {
                        var prevPt = curve.points[i - 1];
                        ctx.bezierCurveTo(prevPt.out.x, prevPt.out.y, point.in.x, point.in.y, point.pos.x, point.pos.y);
                    }
                }
                ctx.stroke();
            }

            // INIT
            var InitPoints = [
                /*{
                 in: v2(80, 100),
                 pos: v2(100, 100),
                 out: v2(120, 100)
                 },
                 {
                 in: v2(100, 200),
                 pos: v2(200, 200),
                 out: v2(300, 200),
                 },
                 {
                 in: v2(300, 100),
                 pos: v2(300, 100),
                 out: v2(400, 100)
                 }*/
            ];

            var canvas = that.layer2.canvas;
            var ctx = canvas.getContext("2d");
            var curve = new Curve(InitPoints);

            var MODE_PEN = 1; // 钢笔工具
            var MODE_OP = 2; // 锚点工具
            var MODE_DEL = 3; // 删除锚点工具
            var MODE_ADD = 4; // 添加锚点工具
            var MODE_MOVE = 5; // 移动锚点工具
            that.penMode = MODE_PEN;
            var drawing = false;

            var startX = 0;
            var startY = 0;
            drawCanvas();
            // CONTROL POSITION ==================
            var haveCtrl = false;
            var SqrHitRadius = Math.pow(9, 2);

            var draggingPoint = -1;
            var draggingType = '';

            function getMousePos2(x, y) {
                return v2(x, y);
            }

            function dragStart(x, y, e) {
                startX = x;
                startY = y;

                var mousePos = getMousePos2(x, y);
                haveCtrl = e.ctrlKey;

                // 遍历每一个点
                for (var i = 0; i < curve.points.length; i++) {
                    var point = curve.points[i];

                    //points.push(bezier.start, bezier.startCtrlPoint, bezier.endCtrlPoint, bezier.end);
                    var dis = v2.sqrDistance(point.pos, mousePos);
                    if (dis < SqrHitRadius) {
                        draggingPoint = i;
                        draggingType = 'pos';
                        return;
                    }
                    if (point.in) {
                        dis = v2.sqrDistance(point.in, mousePos);
                        if (dis < SqrHitRadius) {
                            draggingPoint = i;
                            draggingType = 'in';
                            return;
                        }
                    }
                    if (point.out) {
                        dis = v2.sqrDistance(point.out, mousePos);
                        if (dis < SqrHitRadius) {
                            draggingPoint = i;
                            draggingType = 'out';
                            return;
                        }
                    }
                }
            }

            function keepSmooth(point, mousePos, oldPos) {
                if (draggingType === 'pos') {
                    var delta = v2.sub(mousePos, oldPos);
                    if (point.in) {
                        point.in = v2.add(point.in, delta);
                    }
                    if (point.out) {
                        point.out = v2.add(point.out, delta);
                    }
                } else {
                    /*var another;
                     var anotherType;
                     if (draggingType === 'in') {
                     anotherType = 'out';
                     }
                     else if (draggingType === 'out') {
                     anotherType = 'in';
                     }
                     another = point[anotherType];
                     if (another) {
                     var dir = v2.sub(point.pos, mousePos);
                     var len = v2.distance(mousePos, point.pos);
                     if (len > 0.01) {
                     dir = v2.div(dir, len);
                     var anotherLen = v2.distance(another, point.pos);
                     dir = v2.mul(dir, anotherLen);
                     point[anotherType] = v2.add(dir, point.pos);
                     }
                     }*/
                }
            }

            function dragging(x, y) {
                console.log(drawing);
                if (that.penMode === MODE_PEN && drawing) {
                    var points = curve.points;
                    if (points.length) {
                        var prev = points[points.length - 1];

                        that.layer2.clearRect();
                        drawCanvas();
                        ctx.strokeStyle = that.color;
                        ctx.fillStyle = that.color;
                        that.layer2.drawLine(prev.pos.x, prev.pos.y, x, y);
                    }
                }

                if (draggingType) {
                    if (that.penMode === MODE_MOVE || that.penMode === MODE_OP && haveCtrl) {
                        //var mousePos = getMousePos(event);
                        var mousePos = getMousePos2(x, y);

                        var point = curve.points[draggingPoint];
                        var oldPos = point[draggingType];

                        point[draggingType] = mousePos;
                        keepSmooth(point, mousePos, oldPos);

                        curve.computeBeziers();
                        drawCanvas();
                    } else if (that.penMode === MODE_OP) {
                        if (draggingType === 'pos') {

                            var mousePos = getMousePos2(x, y);

                            var p = curve.points[draggingPoint];
                            p.out = mousePos;
                            p.in = v2.add(p.pos, v2.sub(p.pos, p.out));

                            curve.computeBeziers();
                            drawCanvas();
                        } else {
                            var mousePos = getMousePos2(x, y);

                            var point = curve.points[draggingPoint];
                            var oldPos = point[draggingType];

                            point[draggingType] = mousePos;

                            curve.computeBeziers();
                            drawCanvas();
                        }
                    } else if (that.penMode === MODE_DEL) {}
                }
            }

            function dragEnd(x, y, event) {
                if (that.penMode === MODE_OP) {
                    if (x == startX && y == startY) {
                        if (draggingType === 'pos') {
                            var mousePos = getMousePos2(x, y);

                            var p = curve.points[draggingPoint];
                            p.out = p.pos;
                            p.in = p.pos;

                            curve.computeBeziers();
                            drawCanvas();
                        } else if (draggingType === 'in') {
                            var mousePos = getMousePos2(x, y);

                            var p = curve.points[draggingPoint];
                            p.in = p.pos;

                            curve.computeBeziers();
                            drawCanvas();
                        } else if (draggingType === 'out') {
                            var mousePos = getMousePos2(x, y);

                            var p = curve.points[draggingPoint];
                            p.out = p.pos;

                            curve.computeBeziers();
                            drawCanvas();
                        }
                    }
                } else if (that.penMode === MODE_DEL) {}

                if (that.penMode === MODE_DEL || event.ctrlKey) {
                    if (draggingType) {

                        if (draggingType === 'pos') {
                            curve.points.splice(draggingPoint, 1);

                            curve.computeBeziers();
                            drawCanvas();
                        } else {
                            ui.msg('请针对路径的描点进行删除描点工具');
                        }
                    }
                }

                if (that.penMode === MODE_ADD || event.shiftKey) {

                    var points = curve.points;
                    if (points.length > 1) {
                        var prev = points[points.length - 1];
                        prev.out = v2.add(prev.pos, v2.sub(prev.pos, prev.in));
                    }

                    var newPos = getMousePos2(x, y);
                    curve.points.push({
                        pos: newPos,
                        //in: v2.lerp(newPos, prev.out, 0.3)
                        in: newPos,
                        out: newPos
                    });

                    curve.computeBeziers();
                    drawCanvas();

                    event.stopImmediatePropagation();
                }

                if (that.penMode === MODE_PEN) {

                    var points = curve.points;
                    console.log(points.length);
                    if (points.length) {
                        var prev = points[points.length - 1];
                        prev.out = v2.add(prev.pos, v2.sub(prev.pos, prev.in));
                    }

                    var newPos = getMousePos2(x, y);
                    curve.points.push({
                        pos: newPos,
                        //in: v2.lerp(newPos, prev.out, 0.3)
                        in: newPos,
                        out: newPos
                    });

                    drawing = true;

                    curve.computeBeziers();
                    drawCanvas();

                    event.stopImmediatePropagation();
                }

                if (draggingType) {
                    draggingType = '';
                    draggingPoint = -1;
                    //event.stopImmediatePropagation();
                }
            }

            that.handlers[typeId] = {
                select: function select() {
                    curve.points = [];
                    ctx = that.layer2.ctx;
                    that.ctx.strokeStyle = that.color;
                    $('#pen-tools').show();
                },
                unselect: function unselect() {
                    that.layer2.clearRect();
                    ctx = that.layer.ctx;
                    drawPath();
                    $('#pen-tools').hide();
                },
                mousedown: dragStart,
                mousemove: dragging,
                mouseup: dragEnd,
                mouseout: function mouseout() {
                    that.layer2.clearRect();
                    drawCanvas();
                }
            };

            // ANIMATION
            var Speed = 0.01;
            var PointColor = "#F22";

            var bezierIndex = 0;
            var bezierProgress = 0;
            function animate() {
                window.requestAnimationFrame(animate);

                bezierProgress += Speed;
                if (bezierProgress > curve.progresses[bezierIndex]) {
                    if (bezierProgress > 1) {
                        bezierProgress -= 1;
                    }

                    bezierIndex++;
                    bezierIndex %= curve.beziers.length;
                }

                var realProgress = (bezierProgress - (bezierIndex > 0 ? curve.progresses[bezierIndex - 1] : 0)) / curve.ratios[bezierIndex];

                var pos = curve.beziers[bezierIndex].getPointAt(realProgress);

                drawCanvas(Speed);
                drawPoint(pos, PointColor, PointColor, 6);
            }
            //window.requestAnimationFrame(animate);
        }
    });

    DrawBoard.fn.setPenMode = function (mode) {
        var that = this;
        that.penMode = mode;
    };
})(jQuery);

/***/ }),

/***/ "qBwY":
/***/ (function(module, exports) {

// 区域剪裁插件
var DrawBoard = window.DrawBoard;
var context = window.context; // TODO
var $elemMenu = window.$elemMenu; // TODO
var Color = window.Color;
var typeId = DrawBoard.getTypeId();

var linex = [];
var liney = [];

DrawBoard.addPlugin({
  type: typeId,
  name: 'select',
  init: function init() {
    var that = this;

    that.handlers[typeId] = {
      select: function select() {
        console.log('选择2');
        that.ctx.strokeStyle = '#000';
        that.fillStroke = '#333';

        that.cursorLayer.ctx.fillStyle = '#999999';
        that.cursorLayer.ctx.strokeStyle = that.color;
        that.cursorLayer.ctx.lineWidth = 1;
        that.$elem.css('cursor', 'none');
      },
      unselect: function unselect() {
        that.ctx.strokeStyle = 'rgba(250,250,250,1)';
        that.$elem.css('cursor', 'default');
      },
      mousedown: function mousedown(potx, poty) {
        linex.push(potx);
        liney.push(poty);

        that.ctx2.beginPath();
        that.ctx2.moveTo(potx, poty);
      },
      mouseout: function mouseout(potx, poty) {
        that.cursorLayer.ctx.clearRect(0, 0, that.width, that.height);
      },
      mousemove: function mousemove(x, y) {
        if (that.isDown) {
          linex.push(x);
          liney.push(y);
          that.ctx2.lineTo(x, y);

          that.ctx2.lineCap = 'round';
          that.ctx2.lineJoin = 'round';
          that.ctx2.lineWidth = 1;

          var rgb = Color.hex2Rbg(that.color);
          var rgba = 'rgba(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ',' + that.opacity + ')';

          that.ctx2.strokeStyle = 'rgba(254,0,0,1)';
          that.ctx2.globalCompositeOperation = 'destination-out';
          that.ctx2.stroke();

          that.ctx2.strokeStyle = rgba;
          that.ctx2.globalCompositeOperation = 'source-over';
          that.ctx2.stroke();
        }

        // that.cursorLayer.ctx.strokeStyle = that.color
        that.cursorLayer.ctx.strokeStyle = '#999';
        that.cursorLayer.ctx.clearRect(0, 0, that.width, that.height);
        that.cursorLayer.ctx.strokeStyle = '#999';
        that.cursorLayer.drawLine(x - 4, y, x + 4, y);
        that.cursorLayer.drawLine(x, y - 4, x, y + 4);
      },
      mouseup: function mouseup(potx, poty) {
        that.ctx2.clearRect(0, 0, that.width, that.height);

        if (linex.length > 0) {
          var x = linex[0];
          var y = liney[0];
          that.ctx.beginPath();
          that.ctx.moveTo(x, y);

          for (var i = 1; i < linex.length; i++) {
            x = linex[i];
            y = liney[i];
            that.ctx.lineTo(x, y);
          }
          linex.length = 0;
          liney.length = 0;

          that.ctx.lineCap = 'round';
          that.ctx.lineJoin = 'round';
          that.ctx.lineWidth = that.lineWidth;
          var rgb = Color.hex2Rbg(that.color);
          var rgba = 'rgba(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ',' + that.opacity + ')';
          that.ctx.strokeStyle = rgba;
          // that.ctx.fill()

          var context = that.ctx;
          var canvasData = context.getImageData(0, 0, that.width, that.height);
          var binaryData = canvasData;
          context.putImageData(canvasData, 0, 0);
          for (var _x = 0; _x < binaryData.width; _x++) {
            for (var _y = 0; _y < binaryData.height; _y++) {
              if (!that.ctx.isPointInPath(_x, _y)) {
                var idx = (_x + _y * binaryData.width) * 4;
                binaryData.data[idx + 0] = 255; // Red channel
                binaryData.data[idx + 1] = 255; // Green channel
                binaryData.data[idx + 2] = 255; // Blue channel
                binaryData.data[idx + 3] = 0; // Alpha
              }
            }
          }
          context.putImageData(canvasData, 0, 0);
        }
        that.storage();
      },
      contextmenu: function contextmenu(potx, poty, e) {
        context($elemMenu, e);
      }
    };
  }
});

/***/ }),

/***/ "tjb6":
/***/ (function(module, exports) {

// 矩形插件
var DrawBoard = window.DrawBoard;

var typeId = DrawBoard.getTypeId();

DrawBoard.addPlugin({
    type: typeId,
    name: 'rect',
    init: function init() {
        var that = this;

        that.handlers[typeId] = {
            select: function select() {
                that.ctx.strokeStyle = that.color;
            },
            mousedown: function mousedown(potx, poty) {
                that.layer2.show();
            },
            mousemove: function mousemove(potx, poty) {
                if (that.isDown) {
                    that.newx = potx;
                    that.newy = poty;

                    that.ctx2.clearRect(0, 0, that.width, that.height);
                    that.layer2.drawRect(that.oldx, that.oldy, that.newx, that.newy);
                }
            },
            mouseup: function mouseup(potx, poty) {
                that.layer2.clearRect();

                var newx = potx;
                var newy = poty;

                that.layer.drawRect(that.oldx, that.oldy, newx, newy);
                that.storage();
            }
        };
    }
});

/***/ }),

/***/ "uwNC":
/***/ (function(module, exports) {

// 取色工具插件
var DrawBoard = window.DrawBoard;
var $ = window.jQuery;
var Color = window.Color;

var typeId = DrawBoard.getTypeId();

DrawBoard.addPlugin({
    type: typeId,
    name: 'straw',
    init: function init() {
        var that = this;

        that.handlers[typeId] = {
            mousedown: function mousedown(potx, poty) {
                var imgData = that.ctx.getImageData(potx, poty, 10, 10);
                var red = imgData.data[0];
                var green = imgData.data[1];
                var blue = imgData.data[2];
                // var alpha = imgData.data[3]

                var rgb = Color.rbg2Hex([red, green, blue]);
                that.setColor(rgb);
                $('#editor-color').colorpicker('setValue', rgb); // TODO 分离
                // $('#current-color').css('background-color', rgb)
            }
        };
    }
});

/***/ }),

/***/ "vGYV":
/***/ (function(module, exports) {

var $ = window.jQuery;
var DrawBoard = window.DrawBoard;
var ui = window.ui;

$.extend(ui.Dialog.DEFAULTS, {
  // btn: false
});

DrawBoard.fn.loadImageFile = function (file) {
  var that = this;
  var reader = new FileReader();
  reader.onload = function (e) {
    var oImg = document.createElement('img');
    oImg.onload = function () {
      that.canvasSize(oImg.width, oImg.height);
      // that.ctx.drawImage(oImg , 0 ,0 , oImg.width , oImg.height , 0 ,0 , that.width, that.height)
      that.ctx.drawImage(oImg, 0, 0, oImg.width, oImg.height, 0, 0, oImg.width, oImg.height);
      // oDropBox.appendChild(oImg)
      that.storage();
    };
    oImg.src = this.result;
  };
  reader.readAsDataURL(file);
};

DrawBoard.fn.loadDataUrl = function (dataUrl) {
  var _this = this;

  var oImg = document.createElement('img');
  oImg.onload = function () {
    _this.canvasSize(oImg.width, oImg.height);
    // that.ctx.drawImage(oImg , 0 ,0 , oImg.width , oImg.height , 0 ,0 , that.width, that.height)
    _this.ctx.drawImage(oImg, 0, 0, oImg.width, oImg.height, 0, 0, oImg.width, oImg.height);
    // oDropBox.appendChild(oImg)
    _this.storage();
  };
  oImg.src = dataUrl;
};

DrawBoard.fn.dropImage = function () {
  var that = this;

  that.elem.addEventListener('dragenter', function (e) {
    e.stopPropagation();
    e.preventDefault();
    $(e.target).addClass('box-shadow');
    $(e.target).next().show();
  }, false);
  that.elem.addEventListener('dragover', function (e) {
    e.stopPropagation();
    e.preventDefault();
  }, false);
  that.elem.addEventListener('drop', function (e) {
    e.stopPropagation();
    e.preventDefault();

    var fileList = e.dataTransfer.files;
    that.clear();
    that.loadImageFile(fileList[0]); // 这里只取拖拽的第一个，实际中你可以遍历处理file列表
  }, false);
};

/***/ }),

/***/ "vvaA":
/***/ (function(module, exports) {

// 铅笔插件
var DrawBoard = window.DrawBoard;
var Color = window.Color;
var $ = window.jQuery;
var context = window.context; // TODO
var typeId = DrawBoard.getTypeId();
var linex = [];
var liney = [];

var $elemMenu = $('#pencil-dialog');

DrawBoard.addPlugin({
  type: typeId,
  name: 'pencil',
  init: function init() {
    var that = this;

    that.handlers[typeId] = {
      select: function select() {
        that.ctx.strokeStyle = that.color;
        // that.ctx.strokeStyle = 'rgba(0,0,0,.5)'
        that.cursorLayer.ctx.fillStyle = '#999999';
        that.cursorLayer.ctx.strokeStyle = that.color;
        that.cursorLayer.ctx.lineWidth = 1;
        that.$elem.css('cursor', 'none');
      },
      unselect: function unselect() {
        that.ctx.strokeStyle = 'rgba(250,250,250,1)';
        that.$elem.css('cursor', 'default');
      },
      mousedown: function mousedown(potx, poty) {
        linex.push(potx);
        liney.push(poty);

        that.ctx2.beginPath();
        that.ctx2.moveTo(potx, poty);
      },
      mouseout: function mouseout(potx, poty) {
        that.cursorLayer.ctx.clearRect(0, 0, that.width, that.height);
      },
      mousemove: function mousemove(x, y) {
        if (that.isDown) {
          linex.push(x);
          liney.push(y);
          that.ctx2.lineTo(x, y);

          that.ctx2.lineCap = 'round';
          that.ctx2.lineJoin = 'round';
          that.ctx2.lineWidth = that.lineWidth;

          var rgb = Color.hex2Rbg(that.color);
          var rgba = 'rgba(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ',' + that.opacity + ')';

          that.ctx2.strokeStyle = 'rgba(254,0,0,1)';
          that.ctx2.globalCompositeOperation = 'destination-out';
          that.ctx2.stroke();

          that.ctx2.strokeStyle = rgba;
          that.ctx2.globalCompositeOperation = 'source-over';
          that.ctx2.stroke();
        }

        // that.cursorLayer.ctx.strokeStyle = that.color
        that.cursorLayer.ctx.strokeStyle = '#999';
        that.cursorLayer.ctx.clearRect(0, 0, that.width, that.height);
        that.cursorLayer.drawRound(x, y, that.lineWidth / 2, false);
        that.cursorLayer.ctx.strokeStyle = '#999';
        that.cursorLayer.drawLine(x - 4, y, x + 4, y);
        that.cursorLayer.drawLine(x, y - 4, x, y + 4);
      },
      mouseup: function mouseup(potx, poty) {
        that.ctx2.clearRect(0, 0, that.width, that.height);

        if (linex.length > 0) {
          var x = linex[0];
          var y = liney[0];
          that.ctx.beginPath();
          that.ctx.moveTo(x, y);

          for (var i = 1; i < linex.length; i++) {
            x = linex[i];
            y = liney[i];
            that.ctx.lineTo(x, y);
          }
          linex.length = 0;
          liney.length = 0;

          that.ctx.lineCap = 'round';
          that.ctx.lineJoin = 'round';
          that.ctx.lineWidth = that.lineWidth;
          var rgb = Color.hex2Rbg(that.color);
          var rgba = 'rgba(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ',' + that.opacity + ')';
          that.ctx.strokeStyle = rgba;
          that.ctx.stroke();
        }

        if (potx === that.oldx && poty === that.oldy) {
          var _rgb = Color.hex2Rbg(that.color);
          var _rgba = 'rgba(' + _rgb[0] + ',' + _rgb[1] + ',' + _rgb[2] + ',' + that.opacity + ')';
          that.ctx.fillStyle = _rgba;
          that.layer.drawRound(potx, poty, that.lineWidth / 2, true);
        }
        that.storage();
      },
      contextmenu: function contextmenu(potx, poty, e) {
        console.log('上下文');
        context($elemMenu, e);
      },
      mousewheel: function mousewheel(x, y, delta) {
        if (delta > 0) {
          that.lineWidth += 2;
        } else {
          that.lineWidth -= 2;
        }

        if (that.lineWidth < 1) {
          that.lineWidth = 1;
        }
        that.cursorLayer.ctx.clearRect(0, 0, that.width, that.height);
        that.cursorLayer.ctx.strokeStyle = '#999';
        that.cursorLayer.ctx.clearRect(0, 0, that.width, that.height);
        that.cursorLayer.drawRound(x, y, that.lineWidth / 2, false);
        that.cursorLayer.ctx.strokeStyle = '#999';
        that.cursorLayer.drawLine(x - 4, y, x + 4, y);
        that.cursorLayer.drawLine(x, y - 4, x, y + 4);
      }
    };
  }
});

/***/ }),

/***/ "zZHn":
/***/ (function(module, exports) {

// 抓手插件
/* eslint-disable */
(function ($) {
    var typeId = DrawBoard.getTypeId();

    var downX;
    var downY;

    DrawBoard.addPlugin({
        type: typeId,
        name: 'hand',
        init: function init() {
            var that = this;

            that.handlers[typeId] = {
                mousedown: function mousedown(potx, poty) {
                    downX = potx;
                    downY = poty;
                },
                mousemove: function mousemove(x, y) {
                    if (that.isDown) {
                        var elem = document.getElementById('drawboard');
                        elem.scrollTop = downY - y;
                        //elem.scrollLeft = x - downX
                    }
                },
                mouseup: function mouseup(potx, poty) {}
            };
        }
    });
})(jQuery);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.040671b76a740ecbd19f.js